<template>
    <div class="schedule-manage">
        <!-- 查询段（独立白底卡） -->
        <div class="query-box mb10" v-loading="filterLoading">
            <el-form inline :model="formData" size="mini" class="filter-bar">
                <!-- 工单 -->
                <el-form-item prop="work_order" v-if="getCustomFilterShow('work_order')">
                    <OrderProjectFilter mode="work_order" label="工单" search-api="schedule_manage" v-model="woFilter" @del="handleDelFilter('work_order')"/>
                </el-form-item>
                <!-- 客户名称（镜像指派 assign/query.vue：ESelect 远程多选 + 批量粘贴） -->
                <el-form-item prop="company_name" v-if="getCustomFilterShow('company_name')">
                    <CustomInput label="客户名称" @append-click="handleGenAppendClick('company_name', '输入或粘贴客户名称，每行一个')">
                        <ESelect v-model="formData.company_name" filterable
                                   clearable placeholder="请输入客户名称搜索选择" multiple collapse-tags remote reserve-keyword
                                   :loading="searchLoading" ref="company_name"
                                   @visible-change="(val) => handleVisibleChange(val, 'company_name')"
                                   :remote-method="(search) => appEntrySearchList(search, 'company_name')">
                            <p class="option-select">
                                <el-button type="text"
                                           @click="() => handleSelectAll(company_name_DataList, 'company_name', 'all')">全选</el-button>
                                <el-button type="text"
                                           @click="() => handleSelectAll(company_name_DataList, 'company_name', 'cancel')">取消全选</el-button>
                            </p>
                            <el-option v-for="item in company_name_DataList" :key="item.value" :label="item.label"
                                       :value="item.value" />
                        </ESelect>
                        <template #append>
                            <i class="el-icon-document-copy" />
                        </template>
                        <template #appendOrther>
                            <div :style="{ color: 'red', display: 'inline-block' }">
                                <i class="el-icon-close" @click="handleDelFilter('company_name')" />
                            </div>
                        </template>
                    </CustomInput>
                </el-form-item>
                <!-- 集团名称（镜像指派 assign/query.vue：ESelect 远程多选 + 批量粘贴） -->
                <el-form-item prop="bloc_name" v-if="getCustomFilterShow('bloc_name')">
                    <CustomInput label="集团名称" @append-click="handleGenAppendClick('bloc_name', '输入或粘贴集团名称，每行一个')">
                        <ESelect v-model="formData.bloc_name" filterable
                                   clearable placeholder="请输入集团名称搜索选择" multiple collapse-tags remote reserve-keyword
                                   :loading="searchLoading" ref="bloc_name"
                                   @visible-change="(val) => handleVisibleChange(val, 'bloc_name')"
                                   :remote-method="(search) => appEntrySearchList(search, 'bloc_name')">
                            <p class="option-select">
                                <el-button type="text"
                                           @click="() => handleSelectAll(bloc_name_DataList, 'bloc_name', 'all')">全选</el-button>
                                <el-button type="text"
                                           @click="() => handleSelectAll(bloc_name_DataList, 'bloc_name', 'cancel')">取消全选</el-button>
                            </p>
                            <el-option v-for="item in bloc_name_DataList" :key="item.value" :label="item.label"
                                       :value="item.value" />
                        </ESelect>
                        <template #append>
                            <i class="el-icon-document-copy" />
                        </template>
                        <template #appendOrther>
                            <div :style="{ color: 'red', display: 'inline-block' }">
                                <i class="el-icon-close" @click="handleDelFilter('bloc_name')" />
                            </div>
                        </template>
                    </CustomInput>
                </el-form-item>
                <!-- 星级 -->
                <el-form-item prop="bloc_star" v-if="getCustomFilterShow('bloc_star')">
                    <CustomInput label="集团星级">
                        <el-input v-model="formData.bloc_star" placeholder="星级0-5" clearable size="mini" style="width:110px" @input="formData.bloc_star = (formData.bloc_star||'').replace(/[^0-5]/g,'').slice(0,1)"/>
                        <template #append>
                            <i class="el-icon-close" :style="{color:'red'}" @click="handleDelFilter('bloc_star')"/>
                        </template>
                    </CustomInput>
                </el-form-item>
                <!-- 项目 -->
                <el-form-item prop="project_id" v-if="getCustomFilterShow('project_id')">
                    <OrderProjectFilter mode="project_id" label="项目" search-api="schedule_manage" v-model="projFilter" @del="handleDelFilter('project_id')"/>
                </el-form-item>
                <!-- 产品类型 -->
                <el-form-item prop="app_type" v-if="getCustomFilterShow('app_type')">
                    <CustomInput label="产品类型">
                        <SelectAll :options="opt.app_type" v-model="formData.app_type" placeholder="全部"/>
                        <template #append>
                            <i class="el-icon-close" :style="{color:'red'}" @click="handleDelFilter('app_type')"/>
                        </template>
                    </CustomInput>
                </el-form-item>
                <!-- 包体类型 -->
                <el-form-item prop="package_type" v-if="getCustomFilterShow('package_type')">
                    <CustomInput label="包体类型">
                        <SelectAll :options="opt.package_type" v-model="formData.package_type" placeholder="全部"/>
                        <template #append>
                            <i class="el-icon-close" :style="{color:'red'}" @click="handleDelFilter('package_type')"/>
                        </template>
                    </CustomInput>
                </el-form-item>
                <!-- 游戏分类 -->
                <el-form-item prop="game_classify" v-if="getCustomFilterShow('game_classify')">
                    <CustomInput label="游戏分类">
                        <SelectAll :options="opt.game_classify" v-model="formData.game_classify" placeholder="全部"/>
                        <template #append>
                            <i class="el-icon-close" :style="{color:'red'}" @click="handleDelFilter('game_classify')"/>
                        </template>
                    </CustomInput>
                </el-form-item>
                <!-- 媒体 -->
                <el-form-item prop="plat_id" v-if="getCustomFilterShow('plat_id')">
                    <CustomInput label="媒体">
                        <SelectAll :options="opt.plat" v-model="formData.plat_id" placeholder="全部"/>
                        <template #append>
                            <i class="el-icon-close" :style="{color:'red'}" @click="handleDelFilter('plat_id')"/>
                        </template>
                    </CustomInput>
                </el-form-item>
                <!-- 素材类型 -->
                <el-form-item prop="material_type" v-if="getCustomFilterShow('material_type')">
                    <CustomInput label="素材类型">
                        <SelectAll :options="opt.material_type" v-model="formData.material_type" placeholder="全部"/>
                        <template #append>
                            <i class="el-icon-close" :style="{color:'red'}" @click="handleDelFilter('material_type')"/>
                        </template>
                    </CustomInput>
                </el-form-item>
                <!-- 投放场景（任务7543·枚举·口径同指派 opt.delivery_scene） -->
                <el-form-item prop="delivery_scene" v-if="getCustomFilterShow('delivery_scene')">
                    <CustomInput label="投放场景">
                        <SelectAll :options="opt.delivery_scene" v-model="formData.delivery_scene" placeholder="全部"/>
                        <template #append>
                            <i class="el-icon-close" :style="{color:'red'}" @click="handleDelFilter('delivery_scene')"/>
                        </template>
                    </CustomInput>
                </el-form-item>
                <!-- 投放版位（任务7543·枚举·口径同指派 opt.delivery_type） -->
                <el-form-item prop="delivery_type" v-if="getCustomFilterShow('delivery_type')">
                    <CustomInput label="投放版位">
                        <SelectAll :options="opt.delivery_type" v-model="formData.delivery_type" placeholder="全部"/>
                        <template #append>
                            <i class="el-icon-close" :style="{color:'red'}" @click="handleDelFilter('delivery_type')"/>
                        </template>
                    </CustomInput>
                </el-form-item>
                <!-- 任务紧急程度（任务7543·枚举·口径同指派 opt.urgent_level） -->
                <el-form-item prop="urgent_level" v-if="getCustomFilterShow('urgent_level')">
                    <CustomInput label="任务紧急程度">
                        <SelectAll :options="opt.urgent_level" v-model="formData.urgent_level" placeholder="全部"/>
                        <template #append>
                            <i class="el-icon-close" :style="{color:'red'}" @click="handleDelFilter('urgent_level')"/>
                        </template>
                    </CustomInput>
                </el-form-item>
                <!-- 制作部门（待排单无落点·不显·BUG-002-AO 共享筛选门控） -->
                <el-form-item prop="group_id" v-if="!isPool && getCustomFilterShow('group_id')">
                    <CustomInput label="制作部门">
                        <SelectAll :options="opt.group" v-model="formData.group_id" :multiple="false" placeholder="全部"/>
                        <template #append>
                            <i class="el-icon-close" :style="{color:'red'}" @click="handleDelFilter('group_id')"/>
                        </template>
                    </CustomInput>
                </el-form-item>
                <!-- 下单制作部门（o.group_id 原义·三 tab 都有值：待排单尚无落点时它是唯一的组信息） -->
                <el-form-item prop="order_group" v-if="getCustomFilterShow('order_group')">
                    <CustomInput label="下单制作部门">
                        <SelectAll :options="opt.order_group" v-model="formData.order_group" :multiple="false" placeholder="全部"/>
                        <template #append>
                            <i class="el-icon-close" :style="{color:'red'}" @click="handleDelFilter('order_group')"/>
                        </template>
                    </CustomInput>
                </el-form-item>
                <!-- 创建人（任务7543·远程搜索·排单 get_search_list search_type=create_user） -->
                <el-form-item prop="create_uid" v-if="getCustomFilterShow('create_uid')">
                    <CustomInput label="创建人">
                        <SelectAll :options="create_user_DataList" v-model="formData.create_uid" placeholder="全部"/>
                        <template #append>
                            <i class="el-icon-close" :style="{color:'red'}" @click="handleDelFilter('create_uid')"/>
                        </template>
                    </CustomInput>
                </el-form-item>
                <!-- 期望完成日期（日期范围） -->
                <el-form-item prop="expect_finish_date" v-if="getCustomFilterShow('expect_finish_date')">
                    <CustomInput label="期望完成日期">
                        <el-date-picker v-model="formData.expect_finish_date_range" type="daterange" value-format="yyyy-MM-dd"
                            range-separator="至" start-placeholder="开始" end-placeholder="结束" style="width:340px" size="mini" prefix-icon="" clearable/>
                        <template #append>
                            <i class="el-icon-close" :style="{color:'red'}" @click="handleDelFilter('expect_finish_date')"/>
                        </template>
                    </CustomInput>
                </el-form-item>
                <!-- 创建日期（日期范围） -->
                <el-form-item prop="ctime" v-if="getCustomFilterShow('ctime')">
                    <CustomInput label="创建日期">
                        <el-date-picker v-model="formData.ctime_range" type="daterange" value-format="yyyy-MM-dd"
                            range-separator="至" start-placeholder="开始" end-placeholder="结束" style="width:220px" size="mini" prefix-icon="" clearable/>
                        <template #append>
                            <i class="el-icon-close" :style="{color:'red'}" @click="handleDelFilter('ctime')"/>
                        </template>
                    </CustomInput>
                </el-form-item>
                <!-- 是否新品（任务7543·枚举·单选·口径同指派 opt.is_new） -->
                <el-form-item prop="is_new" v-if="getCustomFilterShow('is_new')">
                    <CustomInput label="是否新品">
                        <SelectAll :options="opt.is_new" v-model="formData.is_new" :multiple="false" placeholder="全部"/>
                        <template #append>
                            <i class="el-icon-close" :style="{color:'red'}" @click="handleDelFilter('is_new')"/>
                        </template>
                    </CustomInput>
                </el-form-item>
                <!-- 游戏类型（任务7543·枚举·口径同指派 opt.project_tag11=tag_level2 lv11） -->
                <el-form-item prop="project_tag11" v-if="getCustomFilterShow('project_tag11')">
                    <CustomInput label="游戏类型">
                        <SelectAll :options="opt.project_tag11" v-model="formData.project_tag11" placeholder="全部"/>
                        <template #append>
                            <i class="el-icon-close" :style="{color:'red'}" @click="handleDelFilter('project_tag11')"/>
                        </template>
                    </CustomInput>
                </el-form-item>
                <!-- 游戏题材（任务7543·枚举·口径同指派 opt.project_tag12=tag_level2 lv12） -->
                <el-form-item prop="project_tag12" v-if="getCustomFilterShow('project_tag12')">
                    <CustomInput label="游戏题材">
                        <SelectAll :options="opt.project_tag12" v-model="formData.project_tag12" placeholder="全部"/>
                        <template #append>
                            <i class="el-icon-close" :style="{color:'red'}" @click="handleDelFilter('project_tag12')"/>
                        </template>
                    </CustomInput>
                </el-form-item>
                <!-- 工单标签（任务7543·远程搜索·排单 get_search_list search_type=work_order_label） -->
                <el-form-item prop="work_order_label" v-if="getCustomFilterShow('work_order_label')">
                    <CustomInput label="工单标签">
                        <SelectAll :options="work_order_label_DataList" v-model="formData.work_order_label" placeholder="全部"/>
                        <template #append>
                            <i class="el-icon-close" :style="{color:'red'}" @click="handleDelFilter('work_order_label')"/>
                        </template>
                    </CustomInput>
                </el-form-item>
                <!-- 创建人部门（任务7543·远程搜索·排单 get_search_list search_type=user_group） -->
                <el-form-item prop="user_group" v-if="getCustomFilterShow('user_group')">
                    <CustomInput label="创建人部门">
                        <SelectAll :options="user_group_DataList" v-model="formData.user_group" placeholder="全部"/>
                        <template #append>
                            <i class="el-icon-close" :style="{color:'red'}" @click="handleDelFilter('user_group')"/>
                        </template>
                    </CustomInput>
                </el-form-item>
                <!-- 落点时间（日期范围·与期望完成日同款·排单专属）（待排单无落点·不显·BUG-002-AO 共享筛选门控）
                     2026-08-31 需求方改名：查询项「交付日」→「落点时间」。字段名 delivery/delivery_start/_end 一律不动
                     （后端契约与 params() 白名单零改），只动展示层 label。下面筛选项名单 :993 必须同步，否则
                     「添加筛选项」下拉里仍叫旧名，出现同一个筛选两种叫法。 -->
                <el-form-item prop="delivery" v-if="!isPool && getCustomFilterShow('delivery')">
                    <CustomInput label="落点时间">
                        <el-date-picker v-model="formData.delivery_range" type="daterange" value-format="yyyy-MM-dd"
                            range-separator="至" start-placeholder="开始" end-placeholder="结束" style="width:340px" size="mini" prefix-icon="" clearable/>
                        <template #append>
                            <i class="el-icon-close" :style="{color:'red'}" @click="handleDelFilter('delivery')"/>
                        </template>
                    </CustomInput>
                </el-form-item>
                <!-- 超期标记（排单专属·超期只对待排单·BUG-002-AG：期望完成日<今天） -->
                <el-form-item prop="overdue" v-if="isPool && getCustomFilterShow('overdue')">
                    <CustomInput label="标记">
                        <SelectAll :options="markOptions" v-model="formData.overdue" :multiple="false" placeholder="全部"/>
                        <template #append>
                            <i class="el-icon-close" :style="{color:'red'}" @click="handleDelFilter('overdue')"/>
                        </template>
                    </CustomInput>
                </el-form-item>
                <!-- 优先级（排单专属） -->
                <el-form-item prop="priority" v-if="getCustomFilterShow('priority')">
                    <CustomInput label="优先级">
                        <SelectAll :options="priorityOptions" v-model="formData.priority" :multiple="false" placeholder="全部"/>
                        <template #append>
                            <i class="el-icon-close" :style="{color:'red'}" @click="handleDelFilter('priority')"/>
                        </template>
                    </CustomInput>
                </el-form-item>
                <!-- +添加筛选 -->
                <el-form-item>
                    <FilterPopSelect :list="activeFilterListMap" :value="visibleCustomFilter" @change="onFilterChange"/>
                </el-form-item>
            </el-form>
            <div class="opts">
                <el-button type="primary" size="mini" @click="handleSearch">查询</el-button>
                <el-button size="mini" @click="handleReset">重置</el-button>
            </div>
        </div>

        <!-- 子tab栏（查询卡下方、表格上方，由容器传入） -->
        <ObliqueTags v-if="tabTags.length" :tags="tabTags" :value="activeTab" @tab-click="v=>$emit('tab-switch', v)"/>

        <!-- 表格段（独立白底卡） -->
        <div class="bg-white pt10 pl10 pr10 pb10 borderRadius5">
            <!-- 操作条 -->
            <div class="operation-box mb10">
                <div class="operation-left">
                    <!-- 待排单：一键自动预排（引擎·负责人专属·阶段16不变） -->
                    <el-button v-if="isPool && canPreschedule" type="primary" size="mini" icon="el-icon-magic-stick"
                               :disabled="!preCatAllowed.length"
                               :title="preCatAllowed.length ? '' : '未识别到您负责的素材类型（视频/平面），请联系管理员核对组织架构或部门数据权限'"
                               @click="openPreDialog">一键自动预排</el-button>
                    <el-button size="mini" icon="el-icon-refresh" @click="refresh">刷新</el-button>
                    <span class="op-tip" v-if="isPool">待排单：一键预排引擎自动落点，或手动「落点」（设组+交付日，组与日期都给才进入已排单）。</span>
                    <span class="op-tip" v-else-if="isFinalized">已定版：已进指派池，仅可单独改期（封顶 T+20）；换组/置换/批量请回「已排单」。</span>
                    <span class="op-tip" v-else-if="isOps">运营视图：对自己创建的单可发起「置换申请」（双签）或「改落点申请」（创意负责人单签·改组/日期·排期日已过走此修日期）；组内单可见、其它只读</span>
                    <span class="op-tip" v-else>可对工单进行改落点、调优先级、置换、定版，操作即时生效。已过期的工单不能置换，请用「改落点」更新交付日期；审批中的工单暂不可操作；定版后进入指派流程。</span>
                </div>
                <div class="operation-right">
                    <el-button icon="el-icon-s-operation" size="mini" @click="handleFieldTable">自定义列</el-button>
                    <el-button icon="el-icon-download" size="mini" :loading="exportLoading" @click="exportData">导出</el-button>
                </div>
            </div>

            <!-- 产能水位（选日期 × 各组泳道）·三 tab 都出。待排单 2026-09-15 加回（原 2026-07-01 c3d5b5b1 去掉）：
                 待排单看水位正是为了决定落点；范围沿用 boardScope 与已排/已定版一致（workOrder_v3 需求三·plan §G） -->
            <!-- 产能水位：仅创意/制作可见。运营不再看（决议 2026-07-09·去掉原大类级脱敏泳道） -->
            <div class="water-section mb10" v-if="!isOps">
                <!-- workOrder_v5 §7：快捷 10 个工作日（MM/DD）+ 日期选择器（T+0~T+20 工作日·非工作日禁选）。
                     天轴来自后端 water(days:21) 返回的 distinct date（已按 tb_my_holiday 过滤），选任何一天都不再请求。 -->
                <div class="board-day-pick">
                    <el-radio-group v-model="boardDay" size="mini" :disabled="!boardDays.length">
                        <el-radio-button v-for="d in quickDays" :key="d" :label="d">{{ fmtMD(d) }}</el-radio-button>
                    </el-radio-group>
                    <el-date-picker v-if="boardDays.length" v-model="boardDay" type="date" size="mini" value-format="yyyy-MM-dd"
                                    :clearable="false" :picker-options="boardDayPickerOptions" placeholder="更多日期"
                                    style="width:130px;margin-left:8px"/>
                    <span class="water-sub" v-if="!boardDays.length">暂无水位数据</span>
                </div>
                <div v-if="lanesOfDay.length" class="board-lanes">
                    <!-- 创意/制作：叶组明细泳道（已排/上限/满产 绝对量） -->
                    <template>
                        <div v-for="row in lanesOfDay" :key="row.leaf_group_id" class="lane">
                            <div class="lane-head">
                                <span class="lane-name">{{row.group_name}}<span class="lane-cat">{{catLabel(row.cat_type)}}</span></span>
                                <span class="lane-count" :class="laneLvl(row.used, row.cap, row.expand)">{{row.used}} 单</span>
                            </div>
                            <div class="lane-bar">
                                <i :class="laneLvl(row.used, row.cap, row.expand)" :style="{width: lanePct(row.used, row.cap, row.expand)+'%'}"></i>
                                <span class="limit"></span>
                            </div>
                            <!-- workOrder_v5 §6：去掉写死的「80%上限 NNN」（§5 后上限是变量·刻度线仍留 80% 作保障线）；红/黄按 满产+扩充 的 100%/80% 判 -->
                            <div class="lane-val" :class="laneLvl(row.used, row.cap, row.expand)==='over'?'over':''">
                                已排 {{row.used}} / 满产 {{row.cap}}<span v-if="+row.expand" class="lane-expand"> +扩充 {{row.expand}}</span>
                            </div>
                            <!-- workOrder_v5 §6：产能标签档位 `{key} 已排/cap`（口径同指派管理组内分配水位）；labels 里 cap!==null 的全列（含 0），by_label 多出的 key（含「未知」）补在后面 -->
                            <div class="lane-labs">
                                <span v-for="l in laneLabels(row)" :key="l.key" class="mw-lab" :class="lvlOf(l.n, l.cap)">{{ l.key }} {{ l.n }}<template v-if="l.cap !== null">/{{ l.cap }}</template></span>
                            </div>
                        </div>
                    </template>
                </div>
                <div v-else-if="boardDay" class="lane-empty">暂无已排工单。</div>
            </div>

            <!-- 批量操作区（三条工具条）2026-10-15 workOrder_v5 §11 起移入下方 jt-table 的 affix-prepend 插槽，随表头一起吸顶。 -->

            <!-- 跨 tab 命中引导：搜索下拉的订单域是三 tab 合集(BUG-002-BA)，选中的单可能不在当前 tab。
                 当前 tab 搜空但别的 tab 有结果 → 直接告诉用户去哪个 tab，避免「搜了个寂寞」。 -->
            <el-alert v-if="showCrossTabTip" type="info" show-icon :closable="false" class="mb10"
                      :title="crossTabTipText"/>

            <jt-table v-loading="loading" :data="list" border stripe
                      header-cell-class-name="header-cell" :row-class-name="rowClassName"
                      @selection-change="onSelectionChange"
                      @sort-change="handleSortChange"
                      @header-dragend="handleDragEnd"
                      style="width:100%">
                <!-- 批量操作区：随表头一起吸顶（workOrder_v5 §11·jt-table affix-prepend 插槽）。
                     三条工具条 v-if / 事件 / 样式与移入前一致；跨 tab 提示 el-alert 留在表格外不吸顶。 -->
                <template #affix-prepend>
                    <!-- 待排单·批量落点工具条（设组+交付日，整批升 status1） -->
                    <div class="batch-bar bar-in-affix" v-if="isPool && canPoolEdit">
                        <span class="bb-cnt">已选 <b>{{selection.length}}</b> 单</span>
                        <el-button type="primary" size="mini" :disabled="!selection.length" @click="openPoolBatch">批量落点（设组+交付日）</el-button>
                        <span class="bb-tip op-tip">整批落到目标组+交付日，组与日期都给才进入「已排单」。</span>
                    </div>

                    <!-- 待排单·批量驳回工具条（2026-07-31·三期 §三）：
                         与上面的「批量落点」分开挂——只持有 schedule_reject、没有落点权(canPoolEdit)的用户
                         也要能批量驳回，合在一条 v-if 里会被落点权连坐挡掉。 -->
                    <div class="batch-bar bar-in-affix" v-if="isPool && (canReject || canLabelEdit)">
                        <span class="bb-cnt">已选 <b>{{rawSelection.length}}</b> 单</span>
                        <el-button v-if="canReject" type="danger" size="mini" :disabled="!selection.length" @click="openBatchReject">批量驳回</el-button>
                        <el-button v-if="canLabelEdit" size="mini" :disabled="!labelSelection.length" @click="openBatchLabel">批量修改标签</el-button>
                        <span class="bb-tip op-tip">驳回后工单退回创意侧「被驳回」，排单记录一并清理；已上传素材/审批中的单会被逐单跳过。</span>
                    </div>

                    <!-- 已排单/已定版·批量工具条（创意·仅大组长/创意负责人·阶段17 已定版也放开） -->
                    <!-- 2026-07-31：条件补 canReject —— 只持有驳回权的用户原先整条工具条都不渲染，批量驳回无从下手。
                         2026-10-15 workOrder_v5 §3：条件补 canWithdraw，「批量驳回」后加「批量撤回」（复用 schedule_withdraw 节点）。 -->
                    <div class="batch-bar bar-in-affix" v-if="(isPending || isFinalized) && ((!isOps && (canFinalize || canAdjust || canSwap || canReject || canWithdraw)) || canLabelEdit)">
                        <span class="bb-cnt">已选 <b>{{rawSelection.length}}</b> 单</span>
                        <el-button v-if="canFinalize && isPending" type="success" size="mini" :disabled="!selection.length" @click="handleBatchFinalize">批量定版</el-button>
                        <el-button v-if="canAdjust" size="mini" :disabled="!selection.length" @click="openBatchRelocate">批量改落点</el-button>
                        <el-button v-if="canSwap" size="mini" :disabled="!selection.length" @click="openBatchSwap">批量置换</el-button>
                        <el-button v-if="canReject" type="danger" size="mini" :disabled="!selection.length" @click="openBatchReject">批量驳回</el-button>
                        <el-button v-if="canWithdraw" type="danger" size="mini" :disabled="!selection.length" @click="openBatchWithdraw">批量撤回</el-button>
                        <el-button v-if="canLabelEdit" size="mini" :disabled="!labelSelection.length" @click="openBatchLabel">批量修改标签</el-button>
                        <span class="bb-tip op-tip" v-if="selection.length && !selValid" style="color:#e6a23c">批量置换需勾选<b>同组</b>的源单（跨天放开·当前勾选非同组）；批量改落点不限同组</span>
                        <span class="bb-tip op-tip" v-else>仅对可操作(非审批中)单生效；跨态置换(已排⇄已定版)会解除定版</span>
                    </div>
                </template>
                <!-- 多选列（待排单批量落点 / 已排单·已定版批量操作·阶段17 / 三 tab 批量驳回 / 已排·已定版批量撤回 v5 §3）
                     ⚠️ 2026-07-31 两个分支各补 canReject：原条件只认落点/定版/改落点/置换权，
                        **只持有 schedule_reject 的用户根本看不到勾选框**，批量驳回按钮再亮也点不动。 -->
                <el-table-column v-if="(isPool && (canPoolEdit || canReject || canLabelEdit)) || ((isPending || isFinalized) && ((!isOps && (canFinalize || canAdjust || canSwap || canReject || canWithdraw)) || canLabelEdit))" type="selection" align="center" width="46" :selectable="rowSelectable"/>
                <!-- 序号列（固定，不动） -->
                <el-table-column label="序号" align="center" width="56" fixed="left">
                    <template slot-scope="{$index}">{{ (formData.page-1)*formData.page_size + $index + 1 }}</template>
                </el-table-column>

                <!-- 动态列 -->
                <el-table-column
                    v-for="(col, idx) in columns"
                    :key="col.id + '_' + idx"
                    :prop="col.id"
                    :label="col.display_name"
                    :width="colWidthMap[col.id] || col.width || ''"
                    :min-width="col.width ? '' : 90"
                    :fixed="col.fixed ? col.fixed : false"
                    :sortable="sortableOf(col.id)"
                    align="left">
                    <!-- 双击复制单元格（对齐工单管理/指派管理的 @dblclick copyText） -->
                    <template slot-scope="{row}">
                      <div @dblclick="copyText(cellCopyText(col, row))">
                        <!-- 落点列：组 + 交付日 + 超期/跨类标签 -->
                        <div v-if="col.id === 'plan_target'">
                            <span class="grp-pill">{{ row.group_name || '未分配' }}</span>
                            <div class="oproj">@ <b>{{ row.delivery || '—' }}</b>
                                <el-tag v-if="isPool && row.overdue==1" size="mini" type="danger" class="ml4">超期</el-tag>
                                <el-tag v-if="row.cross_cat==1" size="mini" type="warning" class="ml4">跨大类</el-tag>
                                <el-tag v-if="row.manual_touched==1" size="mini" type="info" class="ml4">人工调过</el-tag>
                            </div>
                        </div>
                        <!-- 超期文本列（超期只对待排单·BUG-002-AG：期望完成日<今天·已排/已定版不显示） -->
                        <div v-else-if="col.id === 'overdue_text'">
                            <el-tag v-if="isPool && row.overdue==1" size="mini" type="danger">超期</el-tag>
                            <span v-else>—</span>
                        </div>
                        <!-- 星级列 -->
                        <div v-else-if="col.id === 'bloc_star'">
                            <span class="stars">{{ '★'.repeat(row.bloc_star||0) }}</span>
                            <span class="star-zero" v-if="!row.bloc_star">未评级</span>
                        </div>
                        <!-- 素材类型 tag -->
                        <div v-else-if="col.id === 'category_group_name'">
                            <el-tag size="mini" :type="catTagType(row)" effect="plain">{{ row.category_group_name || '—' }}</el-tag>
                        </div>
                        <!-- 排期状态 tag -->
                        <div v-else-if="col.id === 'scheduling_status_text'">
                            <el-tag v-if="row.scheduling_status==3" size="mini" type="success" class="tag-finalized">✓ 已定版</el-tag>
                            <el-tag v-else-if="row.scheduling_status==1" size="mini" type="warning" effect="plain">已排单</el-tag>
                            <el-tag v-else size="mini" type="info" effect="plain">待排单</el-tag>
                        </div>
                        <!-- 集团/客户名称（可能数组） -->
                        <div v-else-if="col.id === 'bloc_name' || col.id === 'company_name'">
                            <div v-if="row[col.id] && Array.isArray(row[col.id])">{{ (row[col.id] || []).join('；') || '—' }}</div>
                            <span v-else>{{ row[col.id] || '—' }}</span>
                        </div>
                        <!-- 优先级列：P1~P4（后端存 1-4·非 raw 数字） -->
                        <div v-else-if="col.id === 'priority'">
                            <el-tag size="mini" effect="plain" :type="priorityTagType(row.priority)">{{ priorityLabel(row.priority) }}</el-tag>
                        </div>
                        <!-- 工单标签（任务7543·[{id,name}] 数组·照指派 assign/index.vue tag 渲染，排单无编辑权故不带编辑图标） -->
                        <div v-else-if="col.id === 'work_order_label'">
                            <template v-for="lb in (row.work_order_label || [])">
                                <el-tag type="warning" size="mini" :key="lb.id" class="mr4">{{ lb.name }}</el-tag>
                            </template>
                            <span v-if="!(row.work_order_label && row.work_order_label.length)">—</span>
                        </div>
                        <!-- 需求信息 detail_info（任务7543·[{info,urgent_level,expected_end_time}] 数组·照指派 assign/index.vue 渲染） -->
                        <div v-else-if="col.id === 'detail_info'">
                            <template v-if="row.detail_info && row.detail_info.length">
                                <div v-for="(it, i) in row.detail_info" :key="i" class="mb2">
                                    <span>{{ it.info }}-</span>
                                    <span :class="[it.urgent_level==='加急' ? 'text-color-error' : '']">{{ it.urgent_level }}-{{ it.expected_end_time }}</span>
                                </div>
                            </template>
                            <span v-else>—</span>
                        </div>
                        <!-- 默认文本 -->
                        <span v-else>{{ row[col.id] !== undefined && row[col.id] !== null && row[col.id] !== '' ? row[col.id] : '—' }}</span>
                      </div>
                    </template>
                </el-table-column>

                <!-- 操作列（固定右侧） -->
                <el-table-column label="操作" align="center" width="280" fixed="right">
                    <template slot-scope="{row}">
                        <!-- 详情：所有行、所有 tab 均可见（可见即可看·与操作权解耦） -->
                        <el-button type="text" size="mini" @click="openDetail(row)">详情</el-button>
                        <!-- 改标签（2026-09-14 需求一）：与详情同款放在分支外——只看节点权，不受 isOps/can_operate/审批中影响 -->
                        <!-- 2026-09-15 需求四：待排单行再加操作权门（只读用户——小组长/组员——只留详情）；已排/已定版仍只看节点 -->
                        <el-button v-if="canLabelEdit" type="text" size="mini" @click="openLabel([row])">改标签</el-button>
                        <!-- 待排单（status0）：落点（设组+交付日·组与日期都给才升 status1） -->
                        <template v-if="isPool">
                            <template v-if="canPoolEdit && row.can_operate!=0">
                                <el-button type="text" size="mini" @click="openPoolAdjust(row)">落点</el-button>
                                <el-button type="text" size="mini" @click="openAdjust(row,'priority')">优先级</el-button>
                            </template>
                            <!-- 驳回（2026-07-31）：与落点权解耦单独判——只有 schedule_reject 的用户在待排单 tab 同样能驳。
                                 门见 showRejectBtn（与服务端 rejectOrder 六道门里的前台可判部分对齐）。 -->
                            <el-button v-if="showRejectBtn(row)" type="text" size="mini" :style="{color:'#f56c6c'}" @click="openReject(row)">驳回</el-button>
                            <span v-if="!(canPoolEdit && row.can_operate!=0) && !showRejectBtn(row)" class="op-tip">只读</span>
                        </template>
                        <!-- 已排单(status1)/已定版(status3)·创意操作（阶段17 放开已定版全操作·都还未指派·定版按钮仅待定版） -->
                        <template v-else-if="!isOps">
                            <span v-if="row.order_status!=1" class="op-tip">已进指派池</span>
                            <span v-else-if="row.in_approval==1" class="op-tip" style="color:#e6a23c">审批中·锁定</span>
                            <span v-else-if="row.can_operate!=1" class="op-tip">只读</span>
                            <!-- 有操作权部门(can_operate==1)但角色无任何操作权节点 → 显只读(不留空白·BUG-002-AQ) -->
                            <!-- 2026-07-31：条件补 canReject —— 只持有驳回权的用户原先落到下面的 v-else「只读」，按钮出不来 -->
                            <template v-else-if="(canFinalize && isPending) || canAdjust || canSwap || canWithdraw || canReject">
                                <el-button v-if="canFinalize && isPending" type="text" size="mini" class="text-color-success" @click="handleFinalize(row)">定版</el-button>
                                <el-button v-if="canAdjust" type="text" size="mini" @click="openRelocate(row,false)">改落点</el-button>
                                <el-button v-if="canAdjust" type="text" size="mini" @click="openAdjust(row,'priority')">优先级</el-button>
                                <el-button v-if="canSwap" type="text" size="mini" :disabled="row.is_overdue==1" :title="row.is_overdue==1?'排期日已过，请改落点更新交付日期':''" @click="openSwap(row)">置换</el-button>
                                <el-button v-if="canWithdraw" type="text" size="mini" :style="{color:'#f56c6c'}" @click="openWithdraw(row)">撤回</el-button>
                                <!-- 驳回：本分支已被上面三个 v-else-if 过滤掉「已进指派池 / 审批中 / 只读」三种行，
                                     showRejectBtn 的其余条件在此恒真，故与兄弟按钮同款只判节点权。 -->
                                <el-button v-if="canReject" type="text" size="mini" :style="{color:'#f56c6c'}" @click="openReject(row)">驳回</el-button>
                            </template>
                            <span v-else class="op-tip">只读</span>
                        </template>
                        <!-- 运营对自己单发起申请（已排单/已定版·未指派）：置换(双签·overdue置灰) / 改落点(创意单签·overdue修日期出口) -->
                        <template v-else>
                            <template v-if="canOpsApply && isOwner(row) && row.order_status==1 && row.in_approval!=1">
                                <el-button type="text" size="mini" :disabled="row.is_overdue==1" :title="row.is_overdue==1?'排期日已过，请改走「改落点申请」更新交付日期':''" @click="openOps(row)">发起置换申请</el-button>
                                <el-button type="text" size="mini" @click="openRelocate(row,true)">改落点申请</el-button>
                            </template>
                            <span v-else class="op-tip">{{ row.in_approval==1 ? '审批中' : '只读' }}</span>
                        </template>
                    </template>
                </el-table-column>
            </jt-table>

            <div class="tar mt10">
                <el-pagination background layout="total, prev, pager, next, sizes" :total="total"
                               :current-page="formData.page" :page-size="formData.page_size" :page-sizes="[20,50,100]"
                               @current-change="onPageChange" @size-change="onSizeChange"/>
            </div>
        </div>

        <!-- 改期 / 优先级 弹框（单 + 批量共用） -->
        <el-dialog :title="adjustTitle" :visible.sync="adjustDialog" width="480px" append-to-body>
            <div class="edit-info" v-if="!isBatch && adjustRow">
                <div><span class="k">工单：</span><b>#{{adjustRow.order_id}} {{adjustRow.order_name||'—'}}</b></div>
                <div><span class="k">素材类型/需求/期望：</span>{{adjustRow.category_group_name||'—'}} · {{adjustRow.demand_num||1}}个 · 期望 {{adjustRow.expect_finish_date||'—'}}</div>
                <div><span class="k">当前落点：</span><span class="grp-pill">{{adjustRow.group_name||'未分配'}}</span> @ <b>{{adjustRow.delivery||'—'}}</b></div>
            </div>
            <div class="edit-info" v-else>已选 <b>{{selection.length}}</b> 单，统一应用以下值（仅「待定版」单生效）。</div>

            <div v-if="adjustType==='delivery'">
                <p class="mb6 dialog-tip">改交付日：系统按<b>需求数</b>校验目标组该日产能 ≤80%，放不下则拒（保产能库存一致）。</p>
                <el-date-picker v-model="adjustDelivery" type="date" value-format="yyyy-MM-dd" placeholder="选择交付日" style="width:100%"/>
                <p class="mt6 dialog-tip-sub">落点晚于期望完成日会自动标「超期」；改后锁定不被重排打乱。</p>
            </div>
            <div v-else-if="adjustType==='priority'">
                <p class="mb6 dialog-tip">调优先级（P1~P4）：仅在同档内微调队列次序，不改星级/期望主排序键。</p>
                <el-select v-model="adjustPriority" placeholder="选择优先级" style="width:100%">
                    <el-option :value="1" label="P1 普通"/>
                    <el-option :value="2" label="P2 较高"/>
                    <el-option :value="3" label="P3 高"/>
                    <el-option :value="4" label="P4 紧急"/>
                </el-select>
            </div>
            <span slot="footer">
                <el-button @click="adjustDialog=false">取消</el-button>
                <el-button type="primary" :loading="adjustLoading" @click="doAdjust">确定</el-button>
            </span>
        </el-dialog>

        <!-- 换组 弹框（创意·单·直接生效） -->
        <el-dialog title="换组（移到目标组·直接生效）" :visible.sync="regroupDialog" width="500px" append-to-body>
            <div class="edit-info" v-if="regroupRow">
                <div><span class="k">工单：</span><b>#{{regroupRow.order_id}} {{regroupRow.order_name||'—'}}</b></div>
                <div><span class="k">当前落点：</span><span class="grp-pill">{{regroupRow.group_name||'未分配'}}</span> @ <b>{{regroupRow.delivery||'—'}}</b>（{{regroupRow.category_group_name||'—'}}）</div>
            </div>
            <p class="mb6 dialog-tip">换组 = 把本单移到目标制作组，<b>直接生效</b>（跨天放开·保留交付日·不拦产能）。</p>
            <el-select v-model="regroupGroup" placeholder="选择目标叶子制作组" style="width:100%" filterable>
                <el-option-group label="同素材类型">
                    <el-option v-for="g in regroupSameCat" :key="g.id" :label="g.name+'（'+g.parent_name+'）'" :value="g.id"/>
                </el-option-group>
                <el-option-group label="跨大类 · 破例">
                    <el-option v-for="g in regroupCrossCat" :key="g.id" :label="g.name+'（'+g.parent_name+'）· 跨大类'" :value="g.id"/>
                </el-option-group>
            </el-select>
            <span slot="footer">
                <el-button @click="regroupDialog=false">取消</el-button>
                <el-button type="primary" :loading="regroupLoading" @click="doRegroup">确定换组</el-button>
            </span>
        </el-dialog>

        <!-- 改落点 弹框（组+日期合一·创意直接生效 / 运营改落点申请·阶段17） -->
        <el-dialog :title="relocateIsApply ? '改落点申请（改组/日期·创意负责人单签）' : '改落点（换组+改期·直接生效）'" :visible.sync="relocateDialog" width="520px" append-to-body>
            <div class="edit-info" v-if="relocateRow">
                <div><span class="k">工单：</span><b>#{{relocateRow.order_id}} {{relocateRow.order_name||'—'}}</b></div>
                <div><span class="k">素材大类/期望：</span>{{relocateRow.category_group_name||'—'}} · 期望 {{relocateRow.expect_finish_date||'—'}}</div>
                <div><span class="k">当前落点：</span><span class="grp-pill">{{relocateRow.group_name||'未分配'}}</span> @ <b>{{relocateRow.delivery||'—'}}</b></div>
            </div>
            <p class="mb6 dialog-tip" v-if="relocateIsApply">
                改落点申请 = 调整本单<b>制作组</b>与<b>交付日</b>（已预填原值·改任一或都改）。提交后走<b>创意负责人单签</b>审批，通过即生效。产能由创意把关。
            </p>
            <p class="mb6 dialog-tip" v-else>
                改落点 = 一次调整<b>制作组</b>与<b>交付日</b>（已预填原值·改任一或都改）·<b>直接生效</b>（跨天放开·封顶 T+20·产能超限仅提醒不拦）。
            </p>
            <el-select v-model="relocateGroup" placeholder="选择目标叶子制作组" style="width:100%" filterable class="mb6">
                <el-option-group label="同素材类型">
                    <el-option v-for="g in relocateSameCat" :key="g.id" :label="g.name+'（'+g.parent_name+'）'" :value="g.id"/>
                </el-option-group>
                <el-option-group label="跨大类 · 破例">
                    <el-option v-for="g in relocateCrossCat" :key="g.id" :label="g.name+'（'+g.parent_name+'）· 跨大类'" :value="g.id"/>
                </el-option-group>
            </el-select>
            <el-date-picker v-model="relocateDelivery" type="date" value-format="yyyy-MM-dd" placeholder="选择交付日（T+20 内）" style="width:100%"/>
            <el-input v-if="relocateIsApply" v-model="relocateReason" type="textarea" :rows="2" placeholder="申请原因（可选）" class="mt6"/>
            <p class="mt6 dialog-tip-sub">· 排期日已过的单也可在此更新到有效未来日。改期封顶 T+20，超出后端拒绝。</p>
            <span slot="footer">
                <el-button @click="relocateDialog=false">取消</el-button>
                <el-button type="primary" :loading="relocateLoading" :disabled="!relocateGroup||!relocateDelivery" @click="doRelocate">{{ relocateIsApply ? '提交申请' : '确定改落点' }}</el-button>
            </span>
        </el-dialog>

        <!-- 批量改落点 弹框（组+日期统一·应用全部选中·超产能二次确认·阶段17） -->
        <el-dialog title="批量改落点（统一设组+交付日）" :visible.sync="batchRelocateDialog" width="520px" append-to-body>
            <div class="edit-info">
                <div><span class="k">已勾选：</span><b>{{selection.length}}</b> 单（需求合计 {{selDemand}}），统一落到下方(制作组 + 交付日)。</div>
            </div>
            <p class="mb6 dialog-tip">整批压到<b>同一制作组 + 同一交付日</b>（不要求源组相同·跨天放开·封顶 T+20）。多单压同格子很可能超产能 → 提交前二次确认。</p>
            <el-select v-model="batchRelocateGroup" placeholder="选目标制作组" style="width:100%" filterable class="mb6">
                <el-option v-for="g in leafGroups" :key="g.id" :label="g.name+'（'+g.parent_name+'）'" :value="g.id"/>
            </el-select>
            <el-date-picker v-model="batchRelocateDelivery" type="date" value-format="yyyy-MM-dd" placeholder="选择交付日（T+20 内）" style="width:100%"/>
            <p class="mt6 dialog-tip-sub">· 产能超限仅提醒不拦（操作后黄字提示）；超 T+20 的单后端拒绝。</p>
            <span slot="footer">
                <el-button @click="batchRelocateDialog=false">取消</el-button>
                <el-button type="primary" :loading="batchSubmitting" :disabled="!batchRelocateGroup||!batchRelocateDelivery" @click="doBatchRelocate">确定改落点</el-button>
            </span>
        </el-dialog>

        <!-- 置换 弹框（创意·单·A⇄B 互换·选对手单·直接生效） -->
        <el-dialog title="置换（与另一单互换制作组·直接生效）" :visible.sync="swapDialog" width="540px" append-to-body>
            <div class="edit-info" v-if="swapRow">
                <div><span class="k">本单：</span><b>#{{swapRow.order_id}} {{swapRow.order_name||'—'}}</b> · <span class="grp-pill">{{swapRow.group_name||'未分配'}}</span> @ {{swapRow.delivery||'—'}}</div>
            </div>
            <p class="mb6 dialog-tip">选<b>对手单</b>，二者<b>互换制作组</b>，<b>直接生效</b>（跨天放开·各留各自交付日）。</p>
            <el-select v-model="swapTarget" placeholder="选择对手单" style="width:100%" filterable :loading="swapCandLoading">
                <el-option v-for="o in swapCandidates" :key="o.order_id" :value="o.order_id"
                           :label="'#'+o.order_id+' '+(o.order_name||'')+' · '+(o.group_name||'未分配')+' @ '+(o.delivery||'—')"/>
            </el-select>
            <p class="mt6 dialog-tip-sub" v-if="!swapCandLoading && !swapCandidates.length">无其它可置换的单（你操作权范围内·非审批中）。</p>
            <span slot="footer">
                <el-button @click="swapDialog=false">取消</el-button>
                <el-button type="primary" :loading="swapLoading" :disabled="!swapTarget" @click="doSwap">确定置换</el-button>
            </span>
        </el-dialog>

        <!-- 批量换组 弹框（勾选同组单 → 1 目标组·跨天放开） -->
        <el-dialog title="批量换组" :visible.sync="batchRegroupDialog" width="500px" append-to-body>
            <div class="edit-info">
                <div><span class="k">已勾选：</span><b>{{selection.length}}</b> 单（源组 <b>{{selGroupName}}</b>，共需求 {{selDemand}}）</div>
            </div>
            <p class="mb6 dialog-tip">整批换到目标组（各单交付日不变·跨天放开·跳产能·可跨大类标破例）。</p>
            <el-select v-model="regroupTarget" placeholder="选目标制作组" style="width:100%" filterable>
                <el-option v-for="g in regroupGroups" :key="g.id" :label="g.name+'（'+g.parent_name+'）'" :value="g.id"/>
            </el-select>
            <p class="mt6 dialog-tip-sub">· 目标组仅含有产能配置、且在你操作权内的制作组（已排除源组）。</p>
            <span slot="footer">
                <el-button @click="batchRegroupDialog=false">取消</el-button>
                <el-button type="primary" :loading="batchSubmitting" :disabled="!regroupTarget" @click="doBatchRegroup">确定换组</el-button>
            </span>
        </el-dialog>

        <!-- 批量置换 弹框（源批 ⇄ 被换批·集合互换·跨天放开） -->
        <el-dialog title="批量置换（两批整体互换组）" :visible.sync="batchSwapDialog" width="640px" append-to-body>
            <div class="edit-info">
                <div><span class="k">源批：</span><b>{{selection.length}}</b> 单（<b>{{selGroupName}}</b>，需求合计 {{selDemand}}）</div>
            </div>
            <p class="mb6 dialog-tip">选「被换组」及其要换出的单，与源批<b>整体互换组</b>（数量可不等·跳产能·各保留交付日·跨天放开）。</p>
            <div class="mb6">
                被换组：
                <el-select v-model="swapDstGroup" size="mini" style="width:240px" placeholder="选被换组" filterable @change="loadDstCandidates">
                    <el-option v-for="g in regroupGroups" :key="g.id" :label="g.name+'（'+g.parent_name+'）'" :value="g.id"/>
                </el-select>
            </div>
            <div v-loading="swapDstLoading">
                <el-checkbox-group v-model="swapDstChecked" v-if="swapDstCandidates.length">
                    <div v-for="o in swapDstCandidates" :key="o.order_id" class="dst-row">
                        <el-checkbox :label="o.order_id">#{{o.order_id}} {{o.order_name||''}}｜{{o.group_name||''}} @ {{o.delivery||'—'}}｜需求{{o.material_num||o.demand_num||0}}</el-checkbox>
                    </div>
                </el-checkbox-group>
                <p class="dialog-tip-sub" v-else-if="swapDstGroup">该组无可置换的单。</p>
            </div>
            <p class="mt6 dialog-tip-sub" v-if="swapDstChecked.length">
                净变化：源组「{{selGroupName}}」 -{{selDemand}} +{{swapDstDemand}}　|　被换组「{{swapDstGroupName}}」 -{{swapDstDemand}} +{{selDemand}}（超标以后端为准·不拦）
            </p>
            <span slot="footer">
                <el-button @click="batchSwapDialog=false">取消</el-button>
                <el-button type="primary" :loading="batchSubmitting" :disabled="!swapDstChecked.length" @click="doBatchSwap">确定置换</el-button>
            </span>
        </el-dialog>

        <!-- 一键自动预排 弹框（待排单·引擎·选期望完成时间范围） -->
        <el-dialog title="一键自动预排" :visible.sync="preDialog" width="520px" append-to-body>
            <p class="mb6 dialog-tip">仅对<b>期望完成时间落在范围内</b>的待排单做本次预排；落点按 <b>T+N（默认 T+2）/ 同大类均分 / 组 ≤ 产能比例 / 满留池</b> 规则。</p>
            <!-- 类型：按后端 scheduling/options 下发的 preschedule_cat_types 渲染（workOrder_v5 §4）——
                 含 1 和 2 → 全部/视频/平面；只含一种 → 只显该项且默认选中、不可改（后端同样拒绝越界 cat_type）。 -->
            <div class="mb6">
                <span class="dialog-tip" style="margin-right:8px">类型</span>
                <el-radio-group v-model="preCatType" size="mini" :disabled="preCatAllowed.length < 2">
                    <el-radio-button v-if="preCatAllowed.length >= 2" :label="0">全部</el-radio-button>
                    <el-radio-button v-if="preCatAllowed.includes(1)" :label="1">视频</el-radio-button>
                    <el-radio-button v-if="preCatAllowed.includes(2)" :label="2">平面</el-radio-button>
                </el-radio-group>
                <span class="dialog-tip-sub" style="margin-left:8px" v-if="preCatAllowed.length >= 2">只排选中类型的待排单，另一类型本轮不动。</span>
                <span class="dialog-tip-sub" style="margin-left:8px" v-else>按您所属创意大类，只能预排{{ preCatAllowed.includes(1) ? '视频' : '平面' }}。</span>
            </div>
            <!-- 产能比例（workOrder_v5 §5）：本次把 T+N 当天各叶组水位最多排到满产 × 比例；已排占用照算，多次预排累计不超 100% -->
            <div class="mb6">
                <span class="dialog-tip" style="margin-right:8px">产能比例</span>
                <el-input-number v-model="preRatio" size="mini" :min="1" :max="100" :step="1" :precision="0" step-strictly controls-position="right" style="width:120px"/>
                <span class="dialog-tip-sub" style="margin-left:4px">%</span>
                <span class="dialog-tip-sub" style="margin-left:8px">本次把当天各组水位最多排到满产的 {{ preRatio || 80 }}%；已排的算占用，多次预排累计不超 100%。</span>
            </div>
            <div class="mb6">
                <span class="dialog-tip" style="margin-right:8px">提前天数</span>
                <el-select v-model="preLead" size="mini" style="width:120px" placeholder="T+N">
                    <el-option v-for="n in 20" :key="n" :value="n" :label="'T+' + n"/>
                </el-select>
                <span class="dialog-tip-sub" style="margin-left:8px">T=今天，只排第 N 个工作日那一天的产能（T+1 ~ T+20）。</span>
            </div>
            <el-date-picker v-model="preRange" type="daterange" value-format="yyyy-MM-dd" range-separator="至"
                            start-placeholder="期望起" end-placeholder="期望止" style="width:100%"/>
            <p class="mt10 dialog-tip-sub">· <b>留空</b> = 全量预排（不限范围）。延期单（期望早于今天）始终纳入并置顶。</p>
            <p class="dialog-tip-sub">· 产能满（同大类各组当日都超产能比例）的单<b>留待排单</b>，不强行落。</p>
            <span slot="footer">
                <el-button @click="preDialog=false">取消</el-button>
                <el-button type="primary" :loading="preLoading" @click="doPreschedule">开始预排</el-button>
            </span>
        </el-dialog>

        <!-- 一键预排·结果明细弹框（点「知道啦」再刷新待排列表+徽标·BUG-002-AJ） -->
        <el-dialog title="一键预排结果" :visible.sync="preResultDialog" width="640px" append-to-body
                   :close-on-click-modal="false" custom-class="pre-result-dialog">
            <div v-if="preResult">
                <p class="mb10 dialog-tip">
                    本次<b>净新排 {{preResult.planned.length}} 单</b>；<b>留待排单 {{preResult.stay.length}} 单</b>；<b>跳过 {{preResult.skipped.length}} 单</b>。
                    （已排/已确认/已定版的单不受影响，本次不动）
                </p>

                <!-- 明细区限高滚动（单子多时不撑到窗口高·BUG-002-AJ UI 优化）·summary 固定在上 -->
                <div class="pre-scroll">
                <div class="pre-sec" v-if="preResult.planned.length">
                    <div class="pre-sec-hd ok">✅ 已排入 {{preResult.planned.length}} 单</div>
                    <div class="pre-row" v-for="it in preResult.planned" :key="'p'+it.order_id">
                        <span class="pre-name">#{{it.order_id}} {{it.order_name}}</span>
                        <span class="pre-to">→ <b>{{it.group_name||'—'}}</b> @ {{it.delivery||'—'}}<span v-if="it.overdue" class="pre-od">（晚于期望）</span></span>
                    </div>
                </div>

                <div class="pre-sec" v-if="preResult.stay.length">
                    <div class="pre-sec-hd stay">⏸ 留待排单 {{preResult.stay.length}} 单</div>
                    <div class="pre-row" v-for="it in preResult.stay" :key="'s'+it.order_id">
                        <span class="pre-name">#{{it.order_id}} {{it.order_name}}</span>
                        <el-tag size="mini" :type="it.kind==='oversized'?'danger':'warning'" effect="plain" class="pre-tag">{{it.kind==='oversized'?'超大单':'产能满'}}</el-tag>
                        <span class="pre-reason">{{it.reason}}</span>
                    </div>
                </div>

                <div class="pre-sec" v-if="preResult.skipped.length">
                    <div class="pre-sec-hd skip">⤫ 跳过 {{preResult.skipped.length}} 单</div>
                    <div class="pre-row" v-for="it in preResult.skipped" :key="'k'+it.order_id">
                        <span class="pre-name">#{{it.order_id}} {{it.order_name}}</span>
                        <span class="pre-reason">{{it.reason}}</span>
                    </div>
                </div>

                <p v-if="!preResult.planned.length && !preResult.stay.length && !preResult.skipped.length" class="dialog-tip-sub">本次无可排单（待排单为空或均已在审批中）。</p>
                </div>
            </div>
            <span slot="footer">
                <el-button type="primary" @click="ackPreResult">知道啦</el-button>
            </span>
        </el-dialog>

        <!-- 待排单·单条落点 弹框（设组+交付日·组与日期都给才升 status1） -->
        <el-dialog title="落点（设组+交付日）" :visible.sync="poolDialog" width="520px" append-to-body>
            <div class="edit-info" v-if="poolRow">
                <div><span class="k">工单：</span><b>#{{poolRow.order_id}} {{poolRow.order_name||'—'}}</b></div>
                <div><span class="k">素材大类/期望：</span>{{poolRow.category_group_name||'—'}} · 期望 {{poolRow.expect_finish_date||'—'}}</div>
            </div>
            <p class="mb6 dialog-tip">设<b>目标组</b> + <b>交付日</b>，<b>两者都必填</b> → 提交后进入「已排单」。</p>
            <el-select v-model="poolGroup" placeholder="选择目标叶子制作组" style="width:100%" filterable class="mb6">
                <el-option-group label="同素材类型">
                    <el-option v-for="g in poolSameCat" :key="g.id" :label="g.name+'（'+g.parent_name+'）'" :value="g.id"/>
                </el-option-group>
                <el-option-group label="跨大类 · 破例">
                    <el-option v-for="g in poolCrossCat" :key="g.id" :label="g.name+'（'+g.parent_name+'）· 跨大类'" :value="g.id"/>
                </el-option-group>
            </el-select>
            <el-date-picker v-model="poolDelivery" type="date" value-format="yyyy-MM-dd" placeholder="选择交付日（必填·T+20 内）" style="width:100%"/>
            <p class="mt6 dialog-tip-sub">· 交付日必填（需求方 2026-08-31 拍板：落点必须组+日期一起给，不再允许"只设组"）。改期封顶 T+20，超出后端拒绝；产能超限仅提醒不拦。</p>
            <span slot="footer">
                <el-button @click="poolDialog=false">取消</el-button>
                <el-button type="primary" :loading="poolLoading" :disabled="!poolGroup||!poolDelivery" @click="doPoolAdjust">确定落点</el-button>
            </span>
        </el-dialog>

        <!-- 待排单·批量落点 弹框（整批设组+交付日·status0→1） -->
        <el-dialog title="批量落点（设组+交付日）" :visible.sync="poolBatchDialog" width="520px" append-to-body>
            <div class="edit-info">
                <div><span class="k">已勾选：</span><b>{{selection.length}}</b> 单（共需求 {{selDemand}}）</div>
            </div>
            <p class="mb6 dialog-tip">整批落到<b>目标组</b> + <b>交付日</b>，<b>两者都必填</b> → 提交后整批进入「已排单」。</p>
            <!-- 候选用 leafGroups(全量) 而非 regroupGroups：后者会排除「源组」(selection[0].group_id)，
                 那是给批量换组/批量置换设计的。待排单半落点单(只设组未给日期·Fix I-2)带着 group_id 仍留在池里，
                 复用 regroupGroups 会把它自己那个组从下拉里抹掉 —— 而后端 batchRegroup 对 status=0 是显式放行同组的
                 (ManageSvc:1930 `if ($status !== 0 && $tg === group_id)`)。别再"顺手"改回 regroupGroups。BUG-002-BS
                 注：交付日改必填后不再新产生半落点单，但生产存量 25 条仍要能选回原组，本修复照旧必要。 -->
            <el-select v-model="poolBatchGroup" placeholder="选目标制作组" style="width:100%" filterable class="mb6">
                <el-option v-for="g in leafGroups" :key="g.id" :label="g.name+'（'+g.parent_name+'）'" :value="g.id"/>
            </el-select>
            <el-date-picker v-model="poolBatchDelivery" type="date" value-format="yyyy-MM-dd" placeholder="选择交付日（必填·T+20 内）" style="width:100%"/>
            <p class="mt6 dialog-tip-sub">· 交付日必填（需求方 2026-08-31 拍板：落点必须组+日期一起给，不再允许"只设组"）。目标组仅含有产能配置、且在你操作权内的制作组；产能超限仅提醒不拦。</p>
            <span slot="footer">
                <el-button @click="poolBatchDialog=false">取消</el-button>
                <el-button type="primary" :loading="batchSubmitting" :disabled="!poolBatchGroup||!poolBatchDelivery" @click="doPoolBatch">确定落点</el-button>
            </span>
        </el-dialog>

        <!-- 运营置换申请 弹框（双签会签·选对手单） -->
        <el-dialog title="发起置换申请（运营负责人+创意负责人双签）" :visible.sync="opsDialog" width="540px" append-to-body>
            <div class="edit-info" v-if="opsRow">
                <div><span class="k">本单：</span><b>#{{opsRow.order_id}} {{opsRow.order_name||'—'}}</b> · <span class="grp-pill">{{opsRow.group_name||'未分配'}}</span> @ {{opsRow.delivery||'—'}}</div>
            </div>
            <p class="mb6 dialog-tip">选<b>对手单</b>发起<b>置换申请</b>，二者互换制作组。换<b>自己的单</b>→仅创意负责人审批；换<b>别人运营的单</b>→被换运营 + 创意负责人双签（权责对等·运营上级仅知会）。</p>
            <el-select v-model="opsTarget" placeholder="选择对手单" style="width:100%" filterable :loading="opsCandLoading">
                <el-option v-for="o in opsCandidates" :key="o.order_id" :value="o.order_id"
                           :label="'#'+o.order_id+' '+(o.order_name||'')+' · '+(o.group_name||'未分配')+' @ '+(o.delivery||'—')"/>
            </el-select>
            <p class="mt6 dialog-tip-sub" v-if="!opsCandLoading && !opsCandidates.length">无其它可置换的单（你可见范围内·非审批中）。</p>
            <el-input v-model="opsReason" type="textarea" :rows="2" placeholder="申请理由（选填）" class="mt10"/>
            <span slot="footer">
                <el-button @click="opsDialog=false">取消</el-button>
                <el-button type="primary" :loading="opsLoading" :disabled="!opsTarget" @click="doOps">提交申请</el-button>
            </span>
        </el-dialog>

        <!-- 撤回 弹框（已排/已定版 → 待排单·必填原因）·单条与批量共用，withdrawBatch 区分（workOrder_v5 §3） -->
        <el-dialog :title="withdrawBatch ? '批量撤回至待排单' : '撤回至待排单'" :visible.sync="withdrawDialog" width="480px" append-to-body>
            <div class="edit-info" v-if="!withdrawBatch && withdrawRow">
                <div><span class="k">工单：</span><b>#{{withdrawRow.order_id}} {{withdrawRow.order_name||'—'}}</b></div>
                <div><span class="k">当前落点：</span><span class="grp-pill">{{withdrawRow.group_name||'未分配'}}</span> @ <b>{{withdrawRow.delivery||'—'}}</b></div>
            </div>
            <div class="edit-info" v-else-if="withdrawBatch">
                <div><span class="k">已选：</span><b>{{selection.length}}</b> 单（已排单 / 已定版）</div>
            </div>
            <p class="mb6 dialog-tip">撤回后该单退回<b>待排单</b>池、释放已占产能，下次一键预排会重新参与排座。{{ withdrawBatch ? '已指派 / 审批中 / 无权的单会被逐单跳过并在结果里点名。' : '' }}</p>
            <el-input type="textarea" :rows="3" v-model="withdrawReason" maxlength="200" show-word-limit placeholder="请填写撤回原因（必填）"/>
            <span slot="footer">
                <el-button @click="withdrawDialog=false">取消</el-button>
                <el-button type="primary" :loading="withdrawLoading" @click="submitWithdraw">确定撤回</el-button>
            </span>
        </el-dialog>

        <!-- 驳回 弹框（三 tab 通用·单条 + 批量共用一个弹框·必填原因）
             ⚠️ maxlength=20 与服务端 REJECT_REASON_MAX / 指派侧 maxStrLen:20 严格对齐（同写 rejected_reason 列），
                这里放宽会被后端打回，收紧会让用户填不满指派侧能填的长度。 -->
        <el-dialog :title="rejectBatch ? '批量驳回工单' : '驳回工单'" :visible.sync="rejectDialog" width="480px" append-to-body>
            <div class="edit-info" v-if="!rejectBatch && rejectRow">
                <div><span class="k">工单：</span><b>#{{rejectRow.order_id}} {{rejectRow.order_name||'—'}}</b></div>
                <div><span class="k">当前落点：</span><span class="grp-pill">{{rejectRow.group_name||'未分配'}}</span> @ <b>{{rejectRow.delivery||'—'}}</b></div>
            </div>
            <div class="edit-info" v-else-if="rejectBatch">
                <div><span class="k">已选：</span><b>{{selection.length}}</b> 单</div>
            </div>
            <p class="mb6 dialog-tip">驳回后工单状态变为<b>被驳回</b>并通知下单人，排单记录一并清理（不再占产能）。
                <b>已上传素材</b>或<b>审批中</b>的单不可驳回{{ rejectBatch ? '，会被逐单跳过并在结果里点名' : '' }}。</p>
            <el-input type="textarea" :rows="3" v-model="rejectReason" maxlength="20" show-word-limit placeholder="请填写驳回原因（必填，最多20字）"/>
            <span slot="footer">
                <el-button @click="rejectDialog=false">取消</el-button>
                <el-button type="danger" :loading="rejectLoading" @click="submitReject">确定驳回</el-button>
            </span>
        </el-dialog>

        <!-- 工单详情 弹框（表格·样式对齐工单 jt-table·前两列固定·max-height 内滚·列超宽横向滚动） -->
        <el-dialog title="工单详情" :visible.sync="detailDialog" width="1080px" append-to-body>
            <!-- 双击复制：明细列均为纯文本，直接取单元格渲染结果，无需逐列映射 -->
            <el-table :data="detailList" v-loading="detailLoading" border stripe size="mini"
                      @cell-dblclick="(row, col, cell) => copyText((cell.innerText || '').trim())"
                      header-cell-class-name="header-cell" max-height="560" empty-text="暂无明细" style="width:100%">
                <el-table-column label="任务ID" prop="detail_id" width="90" fixed="left"/>
                <el-table-column label="媒体" width="90" fixed="left" show-overflow-tooltip>
                    <template slot-scope="{row}">{{row.plat_name||'—'}}</template>
                </el-table-column>
                <el-table-column label="投放场景" width="110" show-overflow-tooltip>
                    <template slot-scope="{row}">{{row.delivery_scene_name||'—'}}</template>
                </el-table-column>
                <el-table-column label="版位" width="110" show-overflow-tooltip>
                    <template slot-scope="{row}">{{row.delivery_type_name||'—'}}</template>
                </el-table-column>
                <el-table-column label="素材格式" width="90" show-overflow-tooltip>
                    <template slot-scope="{row}">{{row.material_format||'—'}}</template>
                </el-table-column>
                <el-table-column label="素材尺寸" width="110">
                    <template slot-scope="{row}">{{ (row.width||row.height) ? (row.width + ' * ' + row.height) : '—' }}</template>
                </el-table-column>
                <el-table-column label="素材大小" width="100">
                    <template slot-scope="{row}">{{ row.material_size ? ('<=' + row.material_size + (row.material_size_unit||'')) : '—' }}</template>
                </el-table-column>
                <el-table-column label="时长(s)" width="80">
                    <template slot-scope="{row}">{{ row.material_duration ? row.material_duration : '—' }}</template>
                </el-table-column>
                <el-table-column label="需求数量" prop="material_num" width="80"/>
                <el-table-column label="期望完成" prop="expected_end_time" width="110"/>
                <el-table-column label="紧急程度" width="90">
                    <template slot-scope="{row}">
                        <span :style="{ color: row.urgent_level == 2 ? '#ff0000' : '' }">{{row.urgent_level_text||'—'}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="标签" min-width="150">
                    <template slot-scope="{row}">
                        <el-tag v-for="lb in (row.label_list||[])" :key="lb.id" size="mini" effect="plain" class="ml4 mb2">{{lb.name}}</el-tag>
                        <span v-if="!(row.label_list && row.label_list.length)">—</span>
                    </template>
                </el-table-column>
                <!-- 特殊备注：工单级字段（取详情行 detailRow.special_content·同列表值·每明细行重复展示） -->
                <el-table-column label="特殊备注" min-width="150" show-overflow-tooltip>
                    <template slot-scope="{row}">{{ (detailRow && detailRow.special_content) || '—' }}</template>
                </el-table-column>
                <!-- 内容要求：工单级字段（tb_td_work_order.content·与特殊备注同源同口径·2026-07-22 需求方要求加在其后） -->
                <el-table-column label="内容要求" min-width="180" show-overflow-tooltip>
                    <template slot-scope="{row}">{{ (detailRow && detailRow.content) || '—' }}</template>
                </el-table-column>
                <!-- 避免要素：工单级字段（tb_td_work_order.avoid_content·三兄弟之一·2026-07-23 需求方要求加在内容要求后） -->
                <el-table-column label="避免要素" min-width="180" show-overflow-tooltip>
                    <template slot-scope="{row}">{{ (detailRow && detailRow.avoid_content) || '—' }}</template>
                </el-table-column>
                <!-- 需求信息：工单级字段（取详情行 detailRow.detail_info 数组·同列表值·每明细行重复展示） -->
                <el-table-column label="需求信息" min-width="200">
                    <template slot-scope="{row}">
                        <template v-if="detailRow && detailRow.detail_info && detailRow.detail_info.length">
                            <div v-for="(it, i) in detailRow.detail_info" :key="i" class="mb2">{{ it.info }}</div>
                        </template>
                        <span v-else>—</span>
                    </template>
                </el-table-column>
                <!-- 上传附件（2026-08-31 需求方：放需求信息后面）：工单级字段，与 special_content/detail_info
                     同款「每明细行重复展示」。数据来自 detail_list 出参新增的 attachment（后端 ManageCtrl::detailList
                     改返 {list, attachment}），path 后端已拼好 getImgHost()，此处直接用。
                     ⚠️ 不要改成前端另调 /work_order/get_work_order_info —— 那是工单管理模块的路由，
                     排单管理角色不一定有其 resource 权限，会 403 静默取不到附件。 -->
                <el-table-column label="上传附件" min-width="180">
                    <template slot-scope="{row}">
                        <template v-if="detailAttachment.length">
                            <div v-for="(a, i) in detailAttachment" :key="i" class="mb2">
                                <a :href="a.attachment_path" target="_blank" rel="noopener noreferrer"
                                   class="attach-link">{{ a.attachment_name || '附件' + (i + 1) }}</a>
                            </div>
                        </template>
                        <span v-else>—</span>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>
    </div>
</template>

<script>
    import API from '@/api/workOrder/scheduleManage.js';
    import schedulingAPI from '@/api/workOrder/scheduling.js';
    import materialAPI from '@/api/workOrder/material.js';
    import { tagEditModal } from '../modalMaterial';
    import SelectAll from '@/components/SelectAll';
    import CustomInput from '@/components/CustomInput';
    import FilterPopSelect from '@/views/workOrder/components/filterPopSelect.vue';
    import ObliqueTags from '@/views/workOrder/components/obliqueTags.vue';
    import OrderProjectFilter from '@/views/workOrder/components/orderProjectFilter.vue';
    import { fieldTableModal } from '@/views/workOrder/modal';
    import { batchSelectModal } from '@/components/modal';
    import { uniqBy } from 'lodash';
    import copyTextMixin from '@/mixins/copyText';
    import { setStorage, getStorage } from '@/utils/index.js';

    export default {
        name: 'BoardSchedule',
        mixins: [copyTextMixin],
        components: { SelectAll, CustomInput, FilterPopSelect, ObliqueTags, OrderProjectFilter },
        props: {
            status: { type: Number, default: 2 },
            subType: { type: String, default: 'pending' },
            pageFuncNames: { type: Array, default: () => [] },
            tabTags: { type: Array, default: () => [] },
            activeTab: { type: String, default: '' },
        },
        data() {
            return {
                // 列宽本地记忆（2026-08-31）：与指派/任务/工单管理同款，key 各页独立。
                // 拖动表头 → handleDragEnd 写 localStorage；渲染时 :width 优先取这里的值。
                colWidthMap: getStorage('localStorage', 'scheduleManageTableWidthMap') || {},
                loading: false,
                exportLoading: false,
                filterLoading: false,
                list: [],
                total: 0,
                viewPerm: '', // 后端列表返回的数据权限档(demand_side_perm/creative_team_leader_perm/producer_perm)·决定视图
                selection: [],
                rawSelection: [],   // 表格实际勾选的全量行（含不可操作行）·仅改标签用（2026-09-14）
                waterRows: [],
                boardDay: '',
                opt: {
                    category_group: [], group: [], order_group: [], bloc: [], app_type: [], game_classify: [],
                    plat: [], package_type: [], material_type: [],
                    // 任务7543·排单管理筛选新增9项之6项枚举下拉（口径同指派 search_config）
                    delivery_scene: [], delivery_type: [], urgent_level: [], is_new: [],
                    project_tag11: [], project_tag12: [],
                },
                // 任务7543·3项远程搜索控件的候选列表（走排单 get_search_list·口径同指派）
                create_user_DataList: [],
                work_order_label_DataList: [],
                user_group_DataList: [],
                // 客户/集团名称：ESelect 远程多选候选（镜像指派 assign/query.vue）
                company_name_DataList: [],
                bloc_name_DataList: [],
                searchLoading: false,
                starOptions: [],
                markOptions: [
                    { value: '', label: '全部' },
                    { value: 1, label: '超期' },
                ],
                leafGroups: [],
                // widget filter 状态（工单/项目切换控件）
                woFilter: { type: '1', ids: [], search: '' },
                projFilter: { type: '1', ids: [], search: '' },
                // 动态筛选
                customFilter: [],
                // 顺序对齐指派 assign/query.vue listMap（共有字段按指派序，排单专属字段插末尾）
                listMap: [
                    { name: 'work_order',         label: '工单名称' },
                    { name: 'company_name',       label: '客户名称' },
                    { name: 'bloc_name',          label: '集团名称' },
                    { name: 'bloc_star',          label: '集团星级' },
                    { name: 'project_id',         label: '项目名称' },
                    { name: 'app_type',           label: '产品类型' },
                    { name: 'package_type',       label: '包体类型' },
                    { name: 'game_classify',      label: '游戏分类' },
                    { name: 'plat_id',            label: '媒体' },
                    { name: 'material_type',      label: '素材类型' },
                    { name: 'delivery_scene',     label: '投放场景' },
                    { name: 'delivery_type',      label: '投放版位' },
                    { name: 'urgent_level',       label: '任务紧急程度' },
                    { name: 'group_id',           label: '制作部门' },
                    { name: 'order_group',        label: '下单制作部门' },
                    { name: 'create_uid',         label: '创建人' },
                    { name: 'expect_finish_date', label: '期望完成日期' },
                    { name: 'ctime',              label: '创建日期' },
                    { name: 'is_new',             label: '是否新品' },
                    { name: 'project_tag11',      label: '游戏类型' },
                    { name: 'project_tag12',      label: '游戏题材' },
                    { name: 'work_order_label',   label: '工单标签' },
                    { name: 'user_group',         label: '创建人部门' },
                    // 排单专属（指派无此三项·插末尾）
                    { name: 'delivery',           label: '落点时间' },   // 2026-08-31 改名·与上方 CustomInput label 必须一致
                    { name: 'overdue',            label: '超期标记' },
                    { name: 'priority',           label: '优先级' },
                ],
                priorityOptions: [
                    { value: 1, label: 'P1 普通' },
                    { value: 2, label: 'P2 较高' },
                    { value: 3, label: 'P3 高' },
                    { value: 4, label: 'P4 紧急' },
                ],
                formData: this.defaultForm(),
                // 动态列相关
                columns: [],
                selectList: [],
                modalList: [],
                // plan_target =「落点(制作部门@交付日)」列：一列同时展示制作组与落点时间。
                // 需求方 2026-08-31：该列要可排序，**按落点时间排**（组名排序无业务意义）。
                // 后端两个 ALLOWED_SORT 白名单都已加 'plan_target' => 's.delivery' 的映射。
                // 'delivery' 保留：它是白名单里的既有键，别的入口可能在用。
                sortableFields: ['order_id', 'material_num', 'expect_finish_date', 'ctime', 'bloc_star', 'delivery', 'plan_target'],
                // 改期/优先级
                adjustDialog: false,
                adjustType: '',
                adjustRow: null,
                isBatch: false,
                adjustDelivery: '',
                adjustPriority: 1,
                adjustLoading: false,
                // 换组（创意·单·直接生效）
                regroupDialog: false,
                regroupRow: null,
                regroupGroup: '',
                regroupLoading: false,
                // 改落点（组+日期合一·阶段17）：创意直接生效(relocate) / 运营申请(applyRelocate+reason)
                relocateDialog: false,
                relocateRow: null,
                relocateGroup: '',
                relocateDelivery: '',
                relocateReason: '',
                relocateIsApply: false,
                relocateLoading: false,
                // 批量改落点（组+日期统一·阶段17）
                batchRelocateDialog: false,
                batchRelocateGroup: '',
                batchRelocateDelivery: '',
                // 置换（创意·单·A⇄B·选对手单）
                swapDialog: false,
                swapRow: null,
                swapTarget: '',        // 选中对手单 order_id
                swapCandidates: [],    // 可置换的对手单
                swapCandLoading: false,
                swapLoading: false,
                // 批量换组/置换（对齐预排期·集合互换·跨天放开）
                batchRegroupDialog: false,
                regroupTarget: '',
                regroupGroups: [],        // 目标/被换组候选（有产能·scope内·排除源组）
                batchSwapDialog: false,
                swapDstGroup: '',
                swapDstCandidates: [],    // 被换组的单
                swapDstChecked: [],       // 勾选的被换单 id
                swapDstLoading: false,
                batchSubmitting: false,
                // 运营置换申请（双签·选对手单）
                opsDialog: false,
                opsRow: null,
                opsTarget: '',         // 选中对手单 order_id
                opsCandidates: [],
                opsCandLoading: false,
                opsReason: '',
                opsLoading: false,
                // 待排单·一键预排（引擎·负责人专属）
                preDialog: false,
                preRange: [],
                preLead: 2,
                preCatType: 0,          // 排单类型：0全部 / 1视频 / 2平面（2026-08-26）
                preRatio: 80,           // 产能比例 1~100 整数，默认 80（workOrder_v5 §5）
                preCatAllowed: [1, 2],  // 账号可排类型（scheduling/options.preschedule_cat_types·workOrder_v5 §4）；加载前默认全部
                preLoading: false,
                preResultDialog: false, // 预排结果明细弹框（BUG-002-AJ）
                preResult: null,        // {planned:[], stay:[], skipped:[]}
                // 待排单·单条落点（设组+交付日）
                poolDialog: false,
                poolRow: null,
                poolGroup: '',
                poolDelivery: '',
                poolLoading: false,
                // 待排单·批量落点
                poolBatchDialog: false,
                poolBatchGroup: '',
                poolBatchDelivery: '',
                // 撤回（已排/已定版 → 待排单·必填原因）
                withdrawDialog: false,
                withdrawRow: null,
                withdrawBatch: false,   // workOrder_v5 §3：批量撤回与单条共用弹框
                withdrawReason: '',
                withdrawLoading: false,
                // 驳回（2026-07-31·三期 §三）：单条与批量共用一个弹框，rejectBatch 区分
                rejectDialog: false,
                rejectRow: null,
                rejectBatch: false,
                rejectReason: '',
                rejectLoading: false,
                // 工单详情弹框
                detailDialog: false,
                detailLoading: false,
                detailList: [],
                detailAttachment: [],   // 工单上传附件（detail_list 出参·2026-08-31）
                detailRow: null,
            };
        },
        computed: {
            // 子tab 模式（阶段16）：pool=待排单 status0 / pending=已排单 status1 / finalized=已定版 status3
            isPool() { return this.subType === 'pool'; },
            isPending() { return this.subType === 'pending'; },
            isFinalized() { return this.subType === 'finalized'; },

            // 是否用了工单/项目下拉筛选（这两个 widget 的候选是三 tab 合集，最易出现「选中的单不在当前 tab」）
            hasOrderFilter() {
                const used = f => (f.type === '1' ? !!(f.ids && f.ids.length) : !!f.search);
                return used(this.woFilter) || used(this.projFilter);
            },
            // 当前 tab 搜空、但别的看板 tab 角标 >0 的那些 tab
            otherTabsWithHits() {
                return (this.tabTags || []).filter(t =>
                    ['pool', 'pending', 'finalized'].includes(t.value)
                    && t.value !== this.activeTab
                    && Number(t.num) > 0);
            },
            showCrossTabTip() {
                return !this.loading && !this.list.length && this.hasOrderFilter && this.otherTabsWithHits.length > 0;
            },
            crossTabTipText() {
                const parts = this.otherTabsWithHits.map(t => `${t.label}（${t.num}）`).join('、');
                return `当前 tab 无匹配结果；该筛选在 ${parts} 有结果，点击上方 tab 查看。`;
            },

            canFinalize() { return this.pageFuncNames.includes('schedule_finalize'); },
            canAdjust() { return this.pageFuncNames.includes('schedule_adjust'); },
            canSwap() { return this.pageFuncNames.includes('schedule_swap'); },
            canWithdraw() { return this.pageFuncNames.includes('schedule_withdraw'); },
            // 驳回节点（2026-07-31·三期 §三）：单条 + 批量共用同一个节点，与撤回同款判法
            canReject() { return this.pageFuncNames.includes('schedule_reject'); },
            // 修改工单标签（2026-09-14 workOrder_v3 需求一）：只看节点勾选，不叠 isOps/操作权/can_operate
            canLabelEdit() { return this.pageFuncNames.includes('schedule_label_edit'); },
            // 改标签吃哪份勾选：待排单只吃可操作行(selection·2026-09-15 需求四只读门)；已排/已定版吃全量(rawSelection)
            // 改标签吃全量勾选（三 tab 同口径·2026-09-22 BUG-002-BU：待排单原先只吃 selection(可操作行)，
            //   只读行勾了也进不了批量）；其余批量操作照旧只吃 selection。
            labelSelection() { return this.rawSelection; },
            canOpsApply() { return this.pageFuncNames.includes('ops_apply'); },
            // 一键预排（引擎·负责人专属节点·阶段16不变）
            // workOrder_v5 §4：只认 engine_preschedule（接口 resource 只挂 7036；原 || schedule_adjust 会出现按钮亮、接口 403 的假按钮）
            canPreschedule() { return this.pageFuncNames.includes('engine_preschedule'); },
            // 待排单可编辑（落点）= 非运营 + 有换组/落点权（复用 schedule_adjust/swap 档；运营 demand_side 后端拒绝）
            canPoolEdit() { return !this.isOps && (this.canAdjust || this.canSwap); },
            // 落点目标组按本单大类拆「同大类/跨大类」
            poolCatId() { return this.poolRow ? this.poolRow.category_group_id : null; },
            poolSameCat() { return this.leafGroups.filter(g => this.poolCatId && String(g.p_group_id) === String(this.poolCatId)); },
            poolCrossCat() { return this.leafGroups.filter(g => !this.poolCatId || String(g.p_group_id) !== String(this.poolCatId)); },
            // 运营视图 = 数据权限档为需求方(demand_side_perm)·以后端 view_perm 为准（阶段15）；
            // 列表未加载出 view_perm 前回退到节点判断（仅持 ops_apply 无创意节点）
            isOps() {
                if (this.viewPerm) return this.viewPerm === 'demand_side_perm';
                return this.canOpsApply && !this.canFinalize && !this.canAdjust && !this.canSwap;
            },
            myUid() { return this.$store.state.user.id; },
            adjustTitle() { return { delivery: '改交付日', priority: '调优先级' }[this.adjustType] || '调整'; },
            regroupCatId() { return this.regroupRow ? this.regroupRow.category_group_id : null; },
            regroupSameCat() {
                return this.leafGroups.filter(g => this.regroupCatId && String(g.p_group_id) === String(this.regroupCatId));
            },
            regroupCrossCat() {
                return this.leafGroups.filter(g => !this.regroupCatId || String(g.p_group_id) !== String(this.regroupCatId));
            },
            // 改落点目标组按本单大类拆「同大类/跨大类」（跨大类默认原日期·阶段17）
            relocateCatId() { return this.relocateRow ? this.relocateRow.category_group_id : null; },
            relocateSameCat() {
                return this.leafGroups.filter(g => this.relocateCatId && String(g.p_group_id) === String(this.relocateCatId));
            },
            relocateCrossCat() {
                return this.leafGroups.filter(g => !this.relocateCatId || String(g.p_group_id) !== String(this.relocateCatId));
            },
            // 批量换组/置换（对齐预排期·跨天放开：只要同组，不要求同天）
            selGroup() { return this.selection.length ? this.selection[0].group_id : ''; },
            selGroupName() { return this.selection.length ? (this.selection[0].group_name || '未分配') : ''; },
            selDemand() { return this.selection.reduce((s, r) => s + (Number(r.material_num || r.demand_num) || 0), 0); },
            selValid() {
                return this.selection.length > 0
                    && this.selection.every(r => String(r.group_id) === String(this.selGroup));
            },
            swapDstGroupName() { const g = this.regroupGroups.find(x => x.id === this.swapDstGroup); return g ? g.name : ''; },
            swapDstDemand() { return this.swapDstCandidates.filter(o => this.swapDstChecked.includes(o.order_id)).reduce((s, o) => s + (Number(o.material_num || o.demand_num) || 0), 0); },
            appMap() { return this.toMap(this.opt.app_type); },
            gameMap() { return this.toMap(this.opt.game_classify); },
            // 水位：distinct date 升序
            // §7：快捷按钮只出前 10 个工作日；选择器可选全部 21 个（boardDays 本身就是经节假日过滤的工作日序列）
            quickDays() { return this.boardDays.slice(0, 10); },
            boardDayPickerOptions() {
                const set = new Set(this.boardDays);
                const pad = n => (n < 10 ? '0' : '') + n;
                return { disabledDate: d => !set.has(`${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`) };
            },
            boardDays() {
                const s = new Set(this.waterRows.map(r => r.date));
                return Array.from(s).sort();
            },
            // 当天各组泳道：按大类 [2平面,1视频] 再按 leaf_group_id 排序
            lanesOfDay() {
                if (!this.boardDay) return [];
                return this.waterRows
                    .filter(r => r.date === this.boardDay)
                    .slice()
                    .sort((a, b) => {
                        const catOrder = v => v === 2 ? 0 : v === 1 ? 1 : 2;
                        const co = catOrder(a.cat_type) - catOrder(b.cat_type);
                        if (co !== 0) return co;
                        // ops 行无 leaf_group_id，回退按大类 id 排
                        const ak = a.leaf_group_id != null ? a.leaf_group_id : a.category_group_id;
                        const bk = b.leaf_group_id != null ? b.leaf_group_id : b.category_group_id;
                        return ak - bk;
                    });
            },
            // 本 tab 渲染不了的筛选项（与模板 v-if 门控一一对应）：
            // 待排单无落点 → 无组/交付日；超期标记只对待排单。
            hiddenFilterNames() {
                return this.isPool ? ['group_id', 'delivery'] : ['overdue'];
            },
            // 动态筛选：弹框只列本 tab 渲染得出来的项，避免勾了不出现
            activeFilterListMap() {
                return this.listMap.filter(item => !this.hiddenFilterNames.includes(item.name));
            },
            // 传给弹框的已勾选集也要同步收窄，否则「全选」态算不出来
            visibleCustomFilter() {
                return this.customFilter.filter(name => !this.hiddenFilterNames.includes(name));
            },
        },
        watch: {
            // 单实例服务待排单/已排单/已定版三 tab（方案C·BUG-002-AO 共享查询）：status 变=切 tab，
            // 重载该状态专属的列集/筛选配置/筛选选项/水位并重查；**formData(筛选值)不重置** → 筛选带着切换 + 自动重查。
            // 注：isPool/isPending/isFinalized 随 subType prop 响应式；此处补齐 mounted 里一次性加载的 status 依赖项。
            status() {
                this.selection = [];
                this.formData.page = 1;
                this.formData.scheduling_status = this.status;
                this.loadOptions();
                this.loadWater();
                this.fetchGetSchedulingFilter(); // → fetchGetCustomField → getList（重载列集+重查）
            },
        },
        mounted() {
            this.loadOptions();
            this.loadWater();
            this.fetchGetSchedulingFilter();
            this.loadFilterSearchLists();
        },
        methods: {
            defaultForm() {
                return {
                    page: 1, page_size: 20,
                    scheduling_status: this.status || '',
                    // 动态筛选字段（work_order/project_id 由 woFilter/projFilter 管理，不在 formData 里）
                    // bloc_name/company_name：ESelect 远程多选（镜像指派 assign/query.vue，数组值）
                    bloc_name: [],
                    company_name: [],
                    app_type: [],
                    game_classify: [],
                    plat_id: [],
                    package_type: [],
                    material_type: [],
                    category_group_id: '',
                    bloc_star: '',
                    // 日期范围（前端 range 字段，查询时拆分为 _start/_end）
                    expect_finish_date_range: [],
                    ctime_range: [],
                    delivery_range: [],
                    group_id: '',
                    order_group: '',
                    overdue: '',
                    priority: '',
                    // 任务7543·排单管理筛选新增9项默认值（口径同指派 formData）
                    delivery_scene: [],
                    delivery_type: [],
                    urgent_level: [],
                    create_uid: [],
                    work_order_label: [],
                    user_group: [],
                    is_new: '',
                    project_tag11: [],
                    project_tag12: [],
                    // 排序
                    order_fields: '', order: '',
                };
            },
            // ——— 动态筛选 ———
            filterFieldType() {
                // 三 tab(待排单/已排单/已定版)共享**同一份**「添加筛选」配置（BUG-002-AO 后续·2026-07-02）——
                // 统一维护一份，加/删筛选项三 tab 同步。复用后端已白名单、可选字段全量的 scheduling_manage_pending_filter。
                // 待排单无落点 → 组/交付日筛选由模板 v-if="!isPool" 隐藏；超期标记 v-if="isPool"·各按 tab 语义显隐。
                return 'scheduling_manage_pending_filter';
            },
            getCustomFilterShow(name) {
                return this.customFilter.includes(name);
            },
            async fetchGetSchedulingFilter() {
                this.filterLoading = true;
                try {
                    const { data } = await schedulingAPI.getSchedulingFilter({ field_type: this.filterFieldType() });
                    const defaults = ['work_order', 'group_id', 'delivery'];
                    this.customFilter = (data && data.length > 0) ? data : defaults;
                } catch (e) {
                    this.customFilter = ['work_order', 'group_id', 'delivery'];
                } finally {
                    this.filterLoading = false;
                    this.fetchGetCustomField();
                }
            },
            async saveSchedulingFilter(filters) {
                try {
                    const filterItems = this.listMap.filter(item => filters.includes(item.name));
                    await schedulingAPI.editSchedulingFilter({ field_type: this.filterFieldType(), filters: filterItems });
                } catch (e) { /* ignore */ }
            },
            onFilterChange(values) {
                // 三 tab 共享一份配置，但弹框只列本 tab 可见项 → emit 回来的 values 不含本 tab 隐藏项。
                // 直接落盘会把另一 tab 的筛选项抹掉，故先把隐藏项从旧配置里 union 回来。
                // 注：handleDelFilter 传入的是含隐藏项的全集，故需去重
                const kept = this.customFilter.filter(name => this.hiddenFilterNames.includes(name));
                const merged = [...new Set([...values, ...kept])];
                this.customFilter = merged;
                // 清除本 tab 中被取消勾选的字段的值（隐藏项不参与，值留给另一 tab）
                this.activeFilterListMap.forEach(({ name }) => {
                    // work_order/project_id 由独立 widget filter 管理，不在 formData 里
                    if (name === 'work_order') {
                        if (!values.includes(name)) this.woFilter = { type: '1', ids: [], search: '' };
                        return;
                    }
                    if (name === 'project_id') {
                        if (!values.includes(name)) this.projFilter = { type: '1', ids: [], search: '' };
                        return;
                    }
                    if (!values.includes(name) && name in this.formData) {
                        const v = this.formData[name];
                        if (Array.isArray(v)) {
                            this.formData[name] = [];
                        } else {
                            this.formData[name] = '';
                        }
                    }
                });
                // 日期 range 字段也清空
                if (!values.includes('expect_finish_date')) this.formData.expect_finish_date_range = [];
                if (!values.includes('ctime')) this.formData.ctime_range = [];
                if (!this.isPool && !values.includes('delivery')) this.formData.delivery_range = [];
                this.saveSchedulingFilter(merged);
            },
            handleDelFilter(name) {
                const idx = this.customFilter.indexOf(name);
                if (idx > -1) {
                    const newFilter = [...this.customFilter];
                    newFilter.splice(idx, 1);
                    this.onFilterChange(newFilter);
                }
            },
            // ——— 客户名称/集团名称：ESelect 远程多选 + 批量粘贴（镜像指派 assign/query.vue，走排单 get_search_list） ———
            async appEntrySearchList(search, type, p = {}, cb) {
                try {
                    const params = {
                        search_type: type,
                        search,
                        ...p
                    };
                    this.searchLoading = true;
                    const { data } = await materialAPI.postScheduleManageSearchList(params);
                    const list = data.list;
                    const errList = data.err_list;
                    if (params.batch_search) {
                        // 第三参 err_groups：后端把「未找到」的单按当前状态归类（仅 search_type=work_order 非空）。
                        // 纯增参数，err_list 与剔除语义一字未动。
                        cb(errList, () => {
                            const ids = list.map(v => v.id);
                            this[`${type}_DataList`] = [
                                ...this[`${type}_DataList`].filter(v => this.formData[type].includes(v.value) && !ids.includes(v.value)),
                                ...list.map(v => {
                                    return {
                                        ...v,
                                        value: v.id,
                                        label: v.name
                                    };
                                })
                            ];
                            this.formData[type] = [...new Set([...this.formData[type], ...ids])];
                        }, data.err_groups || []);
                    } else {
                        this[`${type}_DataList`] = list.map(v => {
                            return {
                                ...v,
                                value: v.id,
                                label: v.name
                            };
                        });
                    }
                } catch (error) {
                    this.$message.warning((error && error.info) || '搜索失败');
                } finally {
                    this.searchLoading = false;
                }
            },
            handleGenAppendClick(type, placeholder) {
                const onSubmit = (data, callback) => {
                    this.appEntrySearchList(
                        '',
                        type,
                        {
                            batch_search: data,
                        },
                        (errs, cb, errGroups) => {
                            callback();
                            if (errs.length) {
                                const onOk = () => {
                                    cb();
                                    vm.close();
                                };
                                // 后端给了归类（仅工单类型）→ 分组弹框；否则退回原弹框，行为与改动前完全一致。
                                // ⚠️ 两条分支的「剔除」动作是同一个 onOk —— 归类只改展示，不改剔除语义。
                                if (errGroups && errGroups.length) {
                                    delErrGroupList({
                                        tip: '未找到以下数据信息，请核实，是否需要剔除未找到的?（已按工单当前状态归类，可分组复制）',
                                        groups: errGroups,
                                        onOk
                                    });
                                } else {
                                    delErrList({
                                        tip: '未找到以下数据信息，请核实，是否需要剔除未找到的?',
                                        list: errs,
                                        onOk
                                    });
                                }
                            } else {
                                cb();
                                vm.close();
                            }
                        }
                    );
                };
                const { vm, delErrList, delErrGroupList } = batchSelectModal({
                    title: type === 'company_name' ? '批量筛选客户名称' : type === 'bloc_name' ? '批量筛选集团名称' : '批量添加',
                    props: {
                        tip: placeholder ? placeholder : '输入或粘贴名称或ID，每行一个',
                        hasLoading: true
                    },
                    cbs: {
                        onSubmit
                    }
                });
            },
            handleVisibleChange(visible, type) {
                if (visible) {
                    const options = this.$refs[type].selected || [];
                    const listData = options.map(v => {
                        return v.$options.propsData;
                    });
                    this.$set(this, `${type}_DataList`, listData);
                }
            },
            handleSelectAll(list, type, selectType) {
                if (selectType === 'all') {
                    const data = [...(this.formData[type] || [])];
                    data.push(...list.map(v => v.value));
                    // 去重 赋值
                    this.formData[type] = [...new Set(data)];
                } else {
                    let optionListIds = this[`${type}_DataList`].map(item => item.value);
                    let channelIds = this.formData[type].filter(item => !optionListIds.includes(item));
                    this.formData[type] = [...channelIds];
                }
            },
            toMap(arr) {
                const m = {};
                (arr || []).forEach(o => { m[o.value !== undefined ? o.value : o.id] = (o.label !== undefined ? o.label : o.name); });
                return m;
            },
            appText(v) { return this.appMap[v] || (v ? '类型' + v : '—'); },
            gameText(v) { return this.gameMap[v] || ''; },
            isOwner(row) { return String(row.owner_uid) === String(this.myUid); },
            catTagType(row) {
                const n = row.category_group_name || '';
                if (n.indexOf('视频') > -1) return '';
                if (n.indexOf('平面') > -1) return 'success';
                return 'info';
            },
            rowClassName({ row }) { return row.scheduling_status == 3 ? 'row-finalized' : ''; },
            // ——— 动态列 ———
            fetchGetCustomField() {
                this.loading = true;
                materialAPI.getCustomField({ field_type: 'scheduling_manage', sub_type: this.subType }).then(res => {
                    const result = res.data;
                    const user_field = result.user_field || [];
                    this.modalList = result.field ? result.field : [];
                    this.selectList = user_field;

                    const reduce_list = [];
                    this.modalList.forEach(group => {
                        if (group && group.children && group.children.length > 0) {
                            reduce_list.push(...group.children);
                        }
                    });

                    const uni_fixed_data = [];
                    const uni_drag_data = [];

                    for (const item of user_field) {
                        reduce_list.forEach(el => {
                            if (el.checked) {
                                if (el['config']) {
                                    const toObjectConfig = JSON.parse(el['config']);
                                    if (item == el['id']) {
                                        if (toObjectConfig['fixed']) {
                                            uni_fixed_data.push({
                                                id: el['id'],
                                                width: 160,
                                                display_name: el['display_name'],
                                                fixed: toObjectConfig['fixed'],
                                            });
                                        } else {
                                            uni_drag_data.push({
                                                id: el['id'],
                                                width: 160,
                                                display_name: el['display_name'],
                                                fixed: null,
                                            });
                                        }
                                    }
                                } else {
                                    if (item == el['id']) {
                                        uni_drag_data.push({
                                            id: el['id'],
                                            width: 120,
                                            display_name: el['display_name'],
                                            fixed: null,
                                            disabled: null,
                                        });
                                    }
                                }
                            }
                        });
                    }

                    this.columns = [...uniqBy(uni_fixed_data, 'id'), ...uniqBy(uni_drag_data, 'id')];
                    this.getList();
                }, err => {
                    this.loading = false;
                    this.$message.error((err && err.info) || '获取列配置失败');
                    this.getList();
                });
            },
            // ——— 自定义列弹窗 ———
            handleFieldTable() {
                const { vm } = fieldTableModal({
                    props: {
                        customClass: 'custom-indicator-new apple-custom-indicator',
                        customList: this.modalList,
                        selectList: this.selectList,
                    },
                    cbs: {
                        onSubmit: (data) => {
                            materialAPI.editCustomField({ field_type: 'scheduling_manage', fields: data, sub_type: this.subType }).then(() => {
                                this.list = [];
                                this.fetchGetCustomField();
                                vm.close();
                            }, err => {
                                this.$message.error((err && err.info) || '保存失败');
                            });
                        },
                        onClose: () => {
                            vm.close();
                        },
                    },
                });
            },
            // ——— 排序 ———
            sortableOf(colId) {
                return this.sortableFields.includes(colId) ? 'custom' : false;
            },
            // 列宽拖动记忆（2026-08-31）：实现与指派 assign/index.vue::handleDragEnd 一致。
            // 排单管理这几个 tab 此前只能拖、刷新即还原——本页压根没挂 @header-dragend，
            // 也没在 :width 上读过存储值，属功能缺失而非失效。
            // ⚠️ jt-table 内部 TableHeader 既 v-on="$listeners" 又自己 @header-dragend，
            //    Vue2 同名事件会合并（两个 handler 都执行），故父组件挂载能正常收到回调。
            handleDragEnd(newWidth, oldWidth, column) {
                if (!column || !column.property) return;   // 序号/多选等无 prop 的列不记
                const next = Object.assign({}, this.colWidthMap, { [column.property]: parseInt(newWidth) });
                this.colWidthMap = next;
                setStorage('localStorage', 'scheduleManageTableWidthMap', next);
            },
            handleSortChange({ prop, order }) {
                if (order) {
                    this.formData['order_fields'] = prop;
                    this.formData['order'] = order === 'ascending' ? 'asc' : 'desc';
                } else {
                    this.formData['order_fields'] = '';
                    this.formData['order'] = '';
                }
                this.formData.page = 1;
                this.getList();
            },
            // ——— 构建查询参数（日期范围拆分，work_order/project_id 按 widget type 出参）———
            buildQueryParams() {
                const fd = this.formData;
                const params = { ...fd };
                // 工单 widget：type1 → work_order(ids数组)；type2 → work_order_search(文本)
                if (this.woFilter.type === '1') {
                    if (this.woFilter.ids && this.woFilter.ids.length) {
                        params.work_order = this.woFilter.ids;
                    }
                    delete params.work_order_search;
                } else {
                    if (this.woFilter.search) {
                        params.work_order_search = this.woFilter.search;
                    }
                    delete params.work_order;
                }
                // 项目 widget：type1 → project_id(ids数组)；type2 → project_name_search(文本)
                if (this.projFilter.type === '1') {
                    if (this.projFilter.ids && this.projFilter.ids.length) {
                        params.project_id = this.projFilter.ids;
                    }
                    delete params.project_name_search;
                } else {
                    if (this.projFilter.search) {
                        params.project_name_search = this.projFilter.search;
                    }
                    delete params.project_id;
                }
                // 投放场景/投放版位：选项 id 是同名多 id 的逗号聚合串（group_concat·同名不同底层 id），
                // 提交前拆开成扁平数组，否则后端 array_map('intval', ...) 会把 "3,4,5" 整串只取出 3（口径同指派 handleOnSubmit）。
                ['delivery_scene', 'delivery_type'].forEach(key => {
                    const arr = fd[key] || [];
                    let list = [];
                    arr.forEach(item => { list = list.concat(String(item).split(',')); });
                    params[key] = list;
                });
                // 删除前端 range 字段，替换为后端 _start/_end 字段
                delete params.expect_finish_date_range;
                delete params.ctime_range;
                delete params.delivery_range;
                const efd = fd.expect_finish_date_range || [];
                params.expect_finish_date_start = efd[0] || '';
                params.expect_finish_date_end   = efd[1] || '';
                const ctr = fd.ctime_range || [];
                params.ctime_start = ctr[0] || '';
                params.ctime_end   = ctr[1] || '';
                const dlv = fd.delivery_range || [];
                params.delivery_start = dlv[0] || '';
                params.delivery_end   = dlv[1] || '';
                // 共享 formData（BUG-002-AO）：剔除与当前 tab 无关的残留筛选，避免切 tab 后带上另一 tab 设的值
                if (this.isPool) {
                    // 待排单无落点：不发送组/交付日（前端已 v-if 隐藏这两项·防已排设的值残留致待排单空结果）
                    delete params.group_id;
                    delete params.delivery;
                    delete params.delivery_start;
                    delete params.delivery_end;
                } else {
                    // 已排/已定版无超期概念（BUG-002-AG）：剔除超期标记（仅待排单有意义）
                    delete params.overdue;
                }
                return params;
            },
            // ——— 导出 ———
            async exportData() {
                try {
                    this.exportLoading = true;
                    const res = await API.exportScheduleManage({
                        ...this.buildQueryParams(),
                        scheduling_status: this.status,
                        fields: this.selectList,
                    });
                    this.$message.success((res && res.info) || '导出成功，请稍后下载');
                } catch (error) {
                    this.$message.error((error && error.info) || '导出失败');
                } finally {
                    this.exportLoading = false;
                }
            },
            // ——— 数据加载 ———
            async loadOptions() {
                try {
                    // 待排单走引擎 options（status0 集合）；已排单/已定版走 schedule_manage options（status1/3）
                    const { data } = this.isPool
                        ? await schedulingAPI.getSchedulingOptions({})
                        : await API.getOptions({});
                    this.opt.category_group = data.category_group || [];
                    this.opt.group = data.group || [];
                    this.opt.order_group = data.order_group || [];
                    this.opt.bloc = data.bloc || [];
                    this.opt.plat = data.plat || [];
                    this.opt.package_type = data.package_type || [];
                    this.opt.material_type = data.material_type || [];
                    // 任务7543·6项枚举下拉：待排单走 getSchedulingOptions/已排/已定版走 getOptions，两侧均已补口径同指派
                    this.opt.delivery_scene = data.delivery_scene || [];
                    this.opt.delivery_type = data.delivery_type || [];
                    this.opt.urgent_level = data.urgent_level || [];
                    this.opt.is_new = data.is_new || [];
                    this.opt.project_tag11 = data.project_tag11 || [];
                    this.opt.project_tag12 = data.project_tag12 || [];
                    // workOrder_v5 §4：待排单 options 下发账号可排类型（按组织树推断）；非数组（老后端）视为全部
                    if (this.isPool) {
                        this.preCatAllowed = Array.isArray(data.preschedule_cat_types)
                            ? data.preschedule_cat_types.map(Number).filter(v => v === 1 || v === 2)
                            : [1, 2];
                    }
                    // 星级固定档：无 + 一~五星（不再取数据里出现过的裸数字·BUG-002-AM）
                    this.starOptions = [
                        { value: '', label: '全部' },
                        { value: 0, label: '无' },
                        { value: 1, label: '一星' },
                        { value: 2, label: '二星' },
                        { value: 3, label: '三星' },
                        { value: 4, label: '四星' },
                        { value: 5, label: '五星' },
                    ];
                    // 产品类型/游戏类型：两侧 options 均已返（v4 BUG-002-BT）·别再跨页调集团星级 get_search_options(不勾该节点即 403)
                    this.opt.app_type = data.app_type || [];
                    this.opt.game_classify = data.game_classify || [];
                } catch (e) { /* ignore */ }
                // plat/package_type/material_type：后端 getOptions 已返回（阶段8补·{id,name}），直接用，勿写错静态枚举
            },
            async loadLeafGroups() {
                if (this.leafGroups.length) return;
                try {
                    // 创意：schedule_manage/group_options(挂排单管理 tab 节点·v4 BUG-002-BT 起)·按操作档过滤有产能制作组。
                    //   ⚠️ 别改回 ConfAPI.getSchedulingGroups(/scheduling/group_options 挂产能配置节点)：角色不勾产能配置就 403、下拉全空。
                    // 运营(isOps)：走 schedule_manage/relocate_groups(挂 ops_apply 节点·运营有权)·
                    //   for_apply=1 返回全制作组树(仅名称/结构·无产能数字)·绕过操作档(运营档=需求方组无制作组)。
                    const { data } = this.isOps
                        ? await API.relocateGroups({ only_capacity: 1, for_apply: 1 })
                        : await API.groupOptions({ only_capacity: 1 });
                    const flat = [];
                    const walk = (nodes, parentName) => {
                        (nodes || []).forEach(n => {
                            if (n.is_leaf == 1) flat.push({ id: n.id, name: n.name, parent_name: parentName || '', p_group_id: n.p_group_id });
                            if (n.children && n.children.length) walk(n.children, n.name);
                        });
                    };
                    walk(data || [], '');
                    this.leafGroups = flat;
                } catch (e) { /* ignore */ }
            },
            // 任务7543·3项远程搜索控件候选（创建人/工单标签/创建人部门）：一次性拉取排单管理可见范围内的全量选项，
            // 走已有 get_search_list 接口（挂 7543·三 tab 订单域合集），与 group_id/order_group 一样不随 tab 切换重拉。
            async loadFilterSearchLists() {
                // [search_type(后端 get_search_list 用), 前端 DataList 属性名]
                const jobs = [
                    ['create_user', 'create_user_DataList'],
                    ['work_order_label', 'work_order_label_DataList'],
                    ['user_group', 'user_group_DataList'],
                ];
                await Promise.all(jobs.map(async ([searchType, listProp]) => {
                    try {
                        const { data } = await materialAPI.postScheduleManageSearchList({ search_type: searchType, search: '', batch_search: '' });
                        this[listProp] = (data.list || []).map(v => ({ ...v, value: v.id, label: v.name }));
                    } catch (e) { /* ignore */ }
                }));
            },
            async loadWater() {
                // 三 tab 都拉（待排单 2026-09-15 加回·workOrder_v3 需求三）。
                // 运营(isOps) 不再看产能水位（决议 2026-07-09·产能数据只对创意开放）→ 跳过（后端亦返空）
                if (this.isOps) return;
                try {
                    // 各 tab 统一用 schedule_manage water（泳道 shape：leaf_group_id/cat_type/group_name），
                    // 展示当前各叶组每日已排占用，作为待排单落点/已排单调整的产能上下文。
                    // workOrder_v5 §7：一次拉 T+0~T+20 共 21 个工作日（后端上限 30），快捷 10 个 + 选择器都从这份数据切
                    const { data } = await API.getWater({ days: 21 });
                    this.waterRows = data || [];
                    if (!this.boardDay && this.boardDays.length) {
                        this.boardDay = this.boardDays[0];
                    }
                } catch (e) { /* ignore */ }
            },
            // 当日 100% = 满产 + 当日扩充（扩充满额不打折）；80%上限 = 满产×0.8 + 扩充
            laneMax(cap, expand) { return (+cap || 0) + (+expand || 0); },
            laneLimit(cap, expand) { return (+cap || 0) * 0.8 + (+expand || 0); },
            lanePct(used, cap, expand) { const m = this.laneMax(cap, expand); return m > 0 ? Math.min(100, Math.round(used / m * 100)) : 0; },
            // ⚠️ 「满档」态的 class 名用 lane-full 而非 full：全局 src/assets/css/global.css:68 有
            // .full{height:100%;width:100%}（main.js 全局引入），scoped 挡不住外部规则命中本组件元素，
            // 用 full 会让水位标签/进度条被强行撑成 100%×100%。over / ok 未与全局撞名，保持原样。
            // workOrder_v5 §6：红/黄改按「满产+扩充」的 100% / 80% 判（与指派 assignMemberWater lvl() 同口径）；laneLimit 仅供刻度线语义保留
            laneLvl(used, cap, expand) { const m = this.laneMax(cap, expand); if (!m) return 'ok'; const r = used / m; return r > 1 ? 'over' : r >= 0.8 ? 'lane-full' : 'ok'; },
            lvlOf(used, cap) { if (!cap) return 'ok'; const r = used / cap; return r > 1 ? 'over' : r >= 0.8 ? 'lane-full' : 'ok'; },
            // §6 档位行：labels（cap!==null 全列含 0）+ by_label 多出的 key（含未知·只在有数时出）
            laneLabels(row) {
                const by = row.by_label || {};
                const labels = Array.isArray(row.labels) ? row.labels : [];
                const out = labels.filter(l => l.cap !== null && l.cap !== undefined).map(l => ({ key: l.key, n: +by[l.key] || 0, cap: +l.cap }));
                const seen = new Set(out.map(l => l.key));
                labels.filter(l => (l.cap === null || l.cap === undefined) && by[l.key]).forEach(l => { if (!seen.has(l.key)) { out.push({ key: l.key, n: +by[l.key] || 0, cap: null }); seen.add(l.key); } });
                Object.keys(by).forEach(k => { if (!seen.has(k)) { out.push({ key: k, n: +by[k] || 0, cap: null }); seen.add(k); } });
                return out;
            },
            // §7 快捷按钮文案：YYYY-MM-DD → MM/DD
            fmtMD(d) { return (d || '').length >= 10 ? d.slice(5, 7) + '/' + d.slice(8, 10) : d; },
            // 优先级 P1~P4 文案/色（复用调优先级弹框口径·后端存 1-4）
            priorityLabel(v) { const o = this.priorityOptions.find(x => x.value === Number(v)); return o ? o.label : '—'; },
            priorityTagType(v) { return { 1: 'info', 2: '', 3: 'warning', 4: 'danger' }[Number(v)] || 'info'; },

            // 双击复制：动态列各分支的渲染形态不同（tag/拼接/数组），逐列取「所见即所得」的文本。
            // 复制不到内容的列（超期空、未评级）由 copyText 的空值守卫静默跳过。
            cellCopyText(col, row) {
                switch (col.id) {
                    case 'plan_target':
                        return `${row.group_name || '未分配'} @ ${row.delivery || ''}`.trim();
                    case 'overdue_text':
                        return (this.isPool && row.overdue == 1) ? '超期' : '';
                    case 'bloc_star':
                        return row.bloc_star ? `${row.bloc_star}星` : '未评级';
                    case 'scheduling_status_text':
                        return { 3: '已定版', 1: '已排单' }[Number(row.scheduling_status)] || '待排单';
                    case 'priority':
                        return this.priorityLabel(row.priority);
                    case 'bloc_name':
                    case 'company_name':
                        return Array.isArray(row[col.id]) ? (row[col.id] || []).join('；') : row[col.id];
                    case 'work_order_label':
                        return (row.work_order_label || []).map(l => l.name).join('，');
                    case 'detail_info':
                        return (row.detail_info || []).map(d => `${d.info}-${d.urgent_level}-${d.expected_end_time}`).join('；');
                    default:
                        return row[col.id];
                }
            },
            // 运营脱敏泳道：后端给 signal(red/yellow/green)，映射到既有泳道配色 class
            catLabel(t) { return { 1: '视频', 2: '平面' }[t] || '—'; },
            async getList() {
                this.loading = true;
                try {
                    let data;
                    if (this.isPool) {
                        // 待排单（status0）走引擎接口 scheduling/pool
                        const r = await schedulingAPI.getSchedulingPool({ ...this.buildQueryParams(), fields: this.selectList });
                        data = r.data || {};
                    } else {
                        const r = await API.getList({
                            ...this.buildQueryParams(),
                            scheduling_status: this.status,
                            fields: this.selectList,
                        });
                        data = r.data || {};
                    }
                    this.list = data.list || [];
                    this.total = data.total || 0;
                    if (data.view_perm) {
                        this.viewPerm = data.view_perm;
                        this.$emit('view-perm', data.view_perm);
                    }
                } catch (error) {
                    this.$message.error((error && error.info) || '加载失败');
                } finally {
                    this.loading = false;
                }
            },
            // refresh 被所有操作成功后 + 刷新按钮调用；handleSearch=查询。都通知父组件重拉 tab 数量(否则排完 badge 停旧值·2026-07-01)
            refresh() { this.selection = []; this.rawSelection = []; this.loadWater(); this.getList(); this.$emit('counts-changed'); },
            // ---- 修改工单标签（三 tab·单行+批量共用·2026-09-14 workOrder_v3 需求一）----
            openBatchLabel() {
                if (!this.labelSelection.length) { this.$message.warning('请先勾选要修改标签的单'); return; }
                this.openLabel(this.labelSelection);
            },
            openLabel(list) {
                const { vm } = tagEditModal({
                    props: {
                        selectList: list,                     // 行已含 order_id/order_name/create_name/work_order_label（单行时弹框回显现有标签）
                        type: 'schedule_manage',
                        // label_options 返回裸数组，弹框读的是 data.work_order_label（与 search_config 同形）→ 这里包一层
                        fetchOptions: () => API.labelOptions({}).then(r => ({ data: { work_order_label: (r && r.data) || [] } })),
                        submit: p => API.batchUpdateLabel({ order_ids: p.order_id, config_ids: p.config_id }),
                    },
                    cbs: { onSubmit: () => { vm.close(); this.refresh(); } },
                });
            },
            handleSearch() { this.formData.page = 1; this.getList(); this.$emit('counts-changed'); },
            handleReset() {
                const ps = this.formData.page_size;
                this.formData = { ...this.defaultForm(), page_size: ps, scheduling_status: this.status };
                this.woFilter = { type: '1', ids: [], search: '' };
                this.projFilter = { type: '1', ids: [], search: '' };
                this.getList();
                this.$emit('counts-changed'); // 重置后徽标恢复全量(BUG-002-AV)
            },
            onPageChange(p) { this.formData.page = p; this.getList(); },
            onSizeChange(s) { this.formData.page_size = s; this.formData.page = 1; this.getList(); },
            onSelectionChange(val) { this.rawSelection = val; this.selection = val.filter(r => this.rowOperable(r)); },
            // ---- 定版 ----
            async handleFinalize(row) {
                try {
                    await this.$confirm('定版后进入指派池、不可再批量调整，确定？', '定版确认', { type: 'warning' });
                } catch (e) { return; }
                try {
                    await API.finalize({ order_id: row.order_id });
                    this.$message.success('定版成功');
                    this.refresh();
                } catch (error) {
                    this.$message.error((error && error.info) || '定版失败');
                }
            },
            async handleBatchFinalize() {
                if (!this.selection.length) { this.$message.warning('请先勾选'); return; }
                try {
                    await this.$confirm('批量定版所选 ' + this.selection.length + ' 单，确定？', '定版确认', { type: 'warning' });
                } catch (e) { return; }
                const ids = this.selection.map(r => r.order_id).join(',');
                try {
                    const { data } = await API.batchFinalize({ order_ids: ids });
                    this.$message.success('已定版 ' + ((data && data.finalized) || 0) + ' 单');
                    this.refresh();
                } catch (error) {
                    this.$message.error((error && error.info) || '批量定版失败');
                }
            },
            // ---- 改期/优先级（单 + 批量·阶段15去顺延） ----
            openAdjust(row, type) {
                this.isBatch = false;
                this.adjustRow = row;
                this.adjustType = type;
                this.adjustDelivery = row.delivery || '';
                // 后端 priority 可能是字符串"1"·el-option :value 是 int → 严格不匹配致 select 显 raw "1" 而非 "P1"·强转 int
                this.adjustPriority = Number(row.priority) || 1;
                this.adjustDialog = true;
            },
            openBatch(type) {
                if (!this.selection.length) { this.$message.warning('请先勾选'); return; }
                this.isBatch = true;
                this.adjustRow = null;
                this.adjustType = type;
                this.adjustDelivery = '';
                this.adjustPriority = 1;
                this.adjustDialog = true;
            },
            async doAdjust() {
                const payload = { type: this.adjustType };
                if (this.adjustType === 'delivery') {
                    if (!this.adjustDelivery) { this.$message.warning('请选择交付日'); return; }
                    payload.delivery = this.adjustDelivery;
                } else if (this.adjustType === 'priority') {
                    payload.priority = this.adjustPriority;
                }
                this.adjustLoading = true;
                try {
                    if (this.isBatch) {
                        payload.order_ids = this.selection.map(r => r.order_id).join(',');
                        const { data } = await API.batchAdjust(payload);
                        this.notifyResult(data, '成功 ' + (data.done || 0) + ' 单' + (data.fail ? '，失败 ' + data.fail : ''));
                    } else {
                        payload.order_id = this.adjustRow.order_id;
                        // 待排单(status0)的优先级走 pool_adjust（statusDomain=[0]）；已排单/已定版走 schedule_manage/adjust
                        const { data } = this.isPool ? await API.poolAdjust(payload) : await API.adjust(payload);
                        this.notifyResult(data, '操作成功');
                    }
                    this.adjustDialog = false;
                    this.refresh();
                } catch (error) {
                    this.$message.error((error && error.info) || '操作失败');
                } finally {
                    this.adjustLoading = false;
                }
            },
            // ---- 换组（创意·单·直接生效） ----
            async openRegroup(row) {
                this.regroupRow = row;
                this.regroupGroup = '';
                await this.loadLeafGroups();
                this.regroupDialog = true;
            },
            async doRegroup() {
                if (!this.regroupGroup) { this.$message.warning('请选择目标组'); return; }
                const g = this.leafGroups.find(x => x.id === this.regroupGroup);
                this.regroupLoading = true;
                try {
                    const { info, data } = await API.regroup({
                        order_id: this.regroupRow.order_id,
                        group_id: this.regroupGroup,
                        category_group_id: g ? g.p_group_id : '',
                    });
                    this.notifyResult(data, info || '换组成功');
                    this.regroupDialog = false;
                    this.refresh();
                } catch (error) {
                    this.$message.error((error && error.info) || '换组失败');
                } finally {
                    this.regroupLoading = false;
                }
            },
            // ---- 改落点（组+日期合一·创意直接生效 / 运营改落点申请·阶段17） ----
            async openRelocate(row, isApply) {
                this.relocateRow = row;
                this.relocateIsApply = !!isApply;
                this.relocateGroup = row.group_id || '';      // 预填原组
                this.relocateDelivery = row.delivery || '';    // 预填原交付日
                this.relocateReason = '';
                await this.loadLeafGroups();
                this.relocateDialog = true;
            },
            async doRelocate() {
                if (!this.relocateGroup) { this.$message.warning('请选择目标组'); return; }
                if (!this.relocateDelivery) { this.$message.warning('请选择交付日'); return; }
                // 大类：换组时从 leafGroups 取目标组父级；运营脱敏(leafGroups空·保持原组)时兜底取本单原大类
                const g = this.leafGroups.find(x => x.id === this.relocateGroup);
                const catId = g ? g.p_group_id : (this.relocateRow.category_group_id || '');
                const payload = {
                    order_id: this.relocateRow.order_id,
                    group_id: this.relocateGroup,
                    category_group_id: catId,
                    delivery: this.relocateDelivery,
                };
                this.relocateLoading = true;
                try {
                    if (this.relocateIsApply) {
                        payload.reason = this.relocateReason;
                        const { info } = await API.applyRelocate(payload);
                        this.$message.success(info || '改落点申请已提交，待创意负责人审批');
                    } else {
                        const { info, data } = await API.relocate(payload);
                        this.notifyResult(data, info || '改落点成功');
                    }
                    this.relocateDialog = false;
                    this.refresh();
                } catch (error) {
                    this.$message.error((error && error.info) || '操作失败');
                } finally {
                    this.relocateLoading = false;
                }
            },
            // ---- 批量改落点（组+日期统一·应用全部选中·超产能二次确认·阶段17） ----
            async openBatchRelocate() {
                if (!this.selection.length) { this.$message.warning('请先勾选'); return; }
                this.batchRelocateGroup = '';
                this.batchRelocateDelivery = '';
                await this.loadLeafGroups();
                this.batchRelocateDialog = true;
            },
            async doBatchRelocate() {
                if (!this.batchRelocateGroup) { this.$message.warning('请选目标组'); return; }
                if (!this.batchRelocateDelivery) { this.$message.warning('请选交付日'); return; }
                const g = this.leafGroups.find(x => x.id === this.batchRelocateGroup);
                try {
                    await this.$confirm(
                        '批量改落点会把已选 ' + this.selection.length + ' 单统一压到同一(制作组 + 交付日)，可能超出该组当日产能（仅提醒不拦）。确认继续？',
                        '批量改落点确认', { type: 'warning' }
                    );
                } catch (e) { return; } // 用户取消
                this.batchSubmitting = true;
                try {
                    const { data } = await API.batchRelocate({
                        order_ids: this.selection.map(r => r.order_id).join(','),
                        group_id: this.batchRelocateGroup,
                        category_group_id: g ? g.p_group_id : '',
                        delivery: this.batchRelocateDelivery,
                    });
                    this.notifyResult(data, '批量改落点完成：成功 ' + ((data && data.done) || 0) + ' 单' + (data && data.fail ? '，失败 ' + data.fail : ''));
                    this.batchRelocateDialog = false;
                    this.selection = [];
                    this.refresh();
                } catch (error) {
                    this.$message.error((error && error.info) || '批量改落点失败');
                } finally {
                    this.batchSubmitting = false;
                }
            },
            // ---- 置换（创意·单·A⇄B·选对手单） ----
            async openSwap(row) {
                this.swapRow = row;
                this.swapTarget = '';
                this.swapCandidates = [];
                this.swapDialog = true;
                this.swapCandLoading = true;
                this.swapCandidates = await this.loadSwapCandidates(row.order_id);
                this.swapCandLoading = false;
            },
            // 加载可置换对手单：本页可见的排单管理单(status2/3)·排除自身·排除审批中
            async loadSwapCandidates(selfId) {
                try {
                    const { data } = await API.getList({ page: 1, page_size: 300 });
                    return (data.list || []).filter(o => o.order_id !== selfId && o.in_approval != 1);
                } catch (e) { return []; }
            },
            // 跨态置换(已排单 status1 ⇄ 已定版 status3)会解除已定版单的定版 → 二次确认；同态(都1/都3)静默直生效（阶段17）
            async confirmCrossStateSwap(statuses) {
                const set = new Set((statuses || []).filter(s => s !== undefined && s !== null).map(s => Number(s)));
                if (!(set.has(1) && set.has(3))) return true; // 同态·无需确认
                try {
                    await this.$confirm(
                        '本次置换同时涉及「已定版」与「待定版」单（跨态），将解除相关已定版单的定版、回到待定版需重新定版。确认继续？',
                        '跨态置换确认', { type: 'warning' }
                    );
                    return true;
                } catch (e) { return false; }
            },
            async doSwap() {
                if (!this.swapTarget) { this.$message.warning('请选择对手单'); return; }
                const target = this.swapCandidates.find(o => o.order_id === this.swapTarget);
                if (!await this.confirmCrossStateSwap([this.swapRow.scheduling_status, target && target.scheduling_status])) return;
                this.swapLoading = true;
                try {
                    const { info, data } = await API.swap({ order_id: this.swapRow.order_id, swap_target_order_id: this.swapTarget });
                    this.notifyResult(data, info || '置换成功');
                    this.swapDialog = false;
                    this.refresh();
                } catch (error) {
                    this.$message.error((error && error.info) || '置换失败');
                } finally {
                    this.swapLoading = false;
                }
            },
            // ---- 批量换组 ----
            // 目标/被换组候选：有产能·排除源组（跨天放开·不限同天）
            async loadRegroupGroups() {
                await this.loadLeafGroups();
                this.regroupGroups = this.leafGroups.filter(g => String(g.id) !== String(this.selGroup));
            },
            async openBatchRegroup() {
                if (!this.selValid) { this.$message.warning('批量换组需勾选「同组」的单'); return; }
                this.regroupTarget = '';
                await this.loadRegroupGroups();
                this.batchRegroupDialog = true;
            },
            async doBatchRegroup() {
                if (!this.regroupTarget) { this.$message.warning('请选目标组'); return; }
                const g = this.leafGroups.find(x => x.id === this.regroupTarget);
                this.batchSubmitting = true;
                try {
                    const { data } = await API.batchRegroup({
                        order_ids: this.selection.map(r => r.order_id).join(','),
                        group_id: this.regroupTarget,
                        category_group_id: g ? g.p_group_id : '',
                    });
                    this.notifyResult(data, '批量换组完成：' + ((data && data.count) || 0) + ' 单');
                    this.batchRegroupDialog = false;
                    this.selection = [];
                    this.refresh();
                } catch (error) {
                    this.$message.error((error && error.info) || '批量换组失败');
                } finally {
                    this.batchSubmitting = false;
                }
            },
            // ---- 批量置换（源批 ⇄ 被换批·集合互换·选被换组勾被换单） ----
            async openBatchSwap() {
                if (!this.selValid) { this.$message.warning('批量置换需勾选「同组」的源单'); return; }
                this.swapDstGroup = '';
                this.swapDstCandidates = [];
                this.swapDstChecked = [];
                await this.loadRegroupGroups();
                this.batchSwapDialog = true;
            },
            // 被换组的单（status2/3·排除审批中·跨天放开不限同天）
            async loadDstCandidates() {
                this.swapDstCandidates = [];
                this.swapDstChecked = [];
                if (!this.swapDstGroup) return;
                this.swapDstLoading = true;
                try {
                    const { data } = await API.getList({ group_id: this.swapDstGroup, page: 1, page_size: 200 });
                    this.swapDstCandidates = ((data && data.list) || []).filter(o => o.in_approval != 1);
                } catch (e) {
                    this.$message.error((e && e.info) || '加载被换组单失败');
                } finally {
                    this.swapDstLoading = false;
                }
            },
            async doBatchSwap() {
                if (!this.swapDstChecked.length) { this.$message.warning('请勾选被换组要换出的单'); return; }
                const statuses = [
                    ...this.selection.map(r => r.scheduling_status),
                    ...this.swapDstCandidates.filter(o => this.swapDstChecked.includes(o.order_id)).map(o => o.scheduling_status),
                ];
                if (!await this.confirmCrossStateSwap(statuses)) return;
                this.batchSubmitting = true;
                try {
                    const { data } = await API.batchSwap({
                        src_ids: this.selection.map(r => r.order_id).join(','),
                        dst_ids: this.swapDstChecked.join(','),
                    });
                    this.notifyResult(data, '批量置换完成：源 ' + ((data && data.src) || 0) + ' 单 ⇄ 被换 ' + ((data && data.dst) || 0) + ' 单');
                    this.batchSwapDialog = false;
                    this.selection = [];
                    this.refresh();
                } catch (error) {
                    this.$message.error((error && error.info) || '批量置换失败');
                } finally {
                    this.batchSubmitting = false;
                }
            },
            // ---- 运营置换申请（双签·选对手单） ----
            async openOps(row) {
                this.opsRow = row;
                this.opsTarget = '';
                this.opsReason = '';
                this.opsCandidates = [];
                this.opsDialog = true;
                this.opsCandLoading = true;
                this.opsCandidates = await this.loadSwapCandidates(row.order_id);
                this.opsCandLoading = false;
            },
            async doOps() {
                if (!this.opsTarget) { this.$message.warning('请选择对手单'); return; }
                const target = this.opsCandidates.find(o => o.order_id === this.opsTarget);
                if (!await this.confirmCrossStateSwap([this.opsRow.scheduling_status, target && target.scheduling_status])) return;
                this.opsLoading = true;
                try {
                    const { info } = await API.opsApply({
                        order_id: this.opsRow.order_id,
                        swap_target_order_id: this.opsTarget,
                        reason: this.opsReason,
                    });
                    this.$message.success(info || '置换申请已提交');
                    this.opsDialog = false;
                    this.refresh();
                } catch (error) {
                    this.$message.error((error && error.info) || '申请发起失败');
                } finally {
                    this.opsLoading = false;
                }
            },
            // ---- 操作结果提醒（共性·防双 toast 重叠·BUG-002-AN） ----
            // 后端返回 capacity_warning（不阻断·如"该日超出制作组产能"）时，把成功文案 + 警告合并成
            // 一条黄色可关闭 toast（6s）；无警告则普通绿色 success。
            // 原先 notifyCapacity(warning) + $message.success(info) 两条同 tick 弹出会重叠，警告被 success 盖住看不见。
            notifyResult(data, successMsg) {
                const w = data && data.capacity_warning;
                const s = successMsg || '操作成功';
                if (w) {
                    this.$message({ type: 'warning', message: s + '；' + w, duration: 6000, showClose: true });
                } else {
                    this.$message.success(s);
                }
            },
            // ---- 待排单·一键自动预排（引擎·负责人专属） ----
            openPreDialog() {
                this.preRange = [];
                this.preLead = 2;
                this.preRatio = 80;
                // 可排两种 → 默认全部(0)；只可排一种 → 默认且只能选那一种（workOrder_v5 §4）
                this.preCatType = this.preCatAllowed.length >= 2 ? 0 : (this.preCatAllowed[0] || 0);
                this.preDialog = true;
            },
            async doPreschedule() {
                const [from, to] = this.preRange || [];
                // el-input-number 清空会 emit undefined → 不静默回退 80，让用户填
                if (!Number.isInteger(this.preRatio) || this.preRatio < 1 || this.preRatio > 100) { this.$message.warning('请填写 1~100 的整数产能比例'); return; }
                this.preLoading = true;
                try {
                    const { data } = await schedulingAPI.preSchedule({
                        range_from: from || '', range_to: to || '',
                        lead_days: this.preLead,
                        cat_type: this.preCatType,   // 0全部 / 1视频 / 2平面
                        fill_ratio: this.preRatio,   // 产能比例 1~100 整数（workOrder_v5 §5·当日水位天花板语义）
                    });
                    const d = data || {};
                    // 留待排单 = 产能满(overflow) + 超大单(oversized) 合一栏，标签区分
                    const stay = [].concat(
                        (d.overflow || []).map(x => ({ ...x, kind: 'overflow' })),
                        (d.oversized || []).map(x => ({ ...x, kind: 'oversized' }))
                    );
                    this.preResult = {
                        planned: d.planned || [],
                        stay,
                        skipped: d.skipped || [],
                    };
                    this.preDialog = false;
                    this.preResultDialog = true; // 出结果弹框·此时不刷新，点「知道啦」再刷
                } catch (error) {
                    this.$message.error((error && error.info) || '预排失败');
                } finally {
                    this.preLoading = false;
                }
            },
            // 结果弹框「知道啦」：关闭 → 刷新待排列表 + tab_counts 徽标（符合交互逻辑·BUG-002-AJ）
            ackPreResult() {
                this.preResultDialog = false;
                this.preResult = null;
                this.refresh();
            },
            // ---- 待排单·单条落点（设组+交付日·status0→1） ----
            async openPoolAdjust(row) {
                this.poolRow = row;
                this.poolGroup = row.group_id || '';
                this.poolDelivery = row.delivery || '';
                await this.loadLeafGroups();
                this.poolDialog = true;
            },
            async doPoolAdjust() {
                if (!this.poolGroup) { this.$message.warning('请选择目标组'); return; }
                // 交付日必填（需求方 2026-08-31）：落点必须组+日期一起给，不再产生"半落点"单
                if (!this.poolDelivery) { this.$message.warning('请选择交付日'); return; }
                const g = this.leafGroups.find(x => x.id === this.poolGroup);
                this.poolLoading = true;
                try {
                    // 单条落点统一走 pool_batch_regroup（单元素 order_ids）：它正确传组+大类，且 delivery 决定升级。
                    // 带 delivery → status0→1；不带 → 仅写组保持 status0（后端规则·brief 注明别用纯 type=group 当落点入口）。
                    const { data } = await API.poolBatchRegroup({
                        order_ids: [this.poolRow.order_id],
                        group_id: this.poolGroup,
                        category_group_id: g ? g.p_group_id : '',
                        delivery: this.poolDelivery || '',
                    });
                    this.notifyResult(data, '落点成功，已进入「已排单」');
                    this.poolDialog = false;
                    this.refresh();
                } catch (error) {
                    this.$message.error((error && error.info) || '落点失败');
                } finally {
                    this.poolLoading = false;
                }
            },
            // ---- 待排单·批量落点（整批设组+交付日） ----
            async openPoolBatch() {
                if (!this.selection.length) { this.$message.warning('请先勾选'); return; }
                this.poolBatchGroup = '';
                this.poolBatchDelivery = '';
                // loadLeafGroups 而非 loadRegroupGroups：待排单落点不存在"源组"概念，不排除任何组。见模板处注释。
                await this.loadLeafGroups();
                this.poolBatchDialog = true;
            },
            async doPoolBatch() {
                if (!this.poolBatchGroup) { this.$message.warning('请选目标组'); return; }
                // 交付日必填（需求方 2026-08-31）：同单条落点口径
                if (!this.poolBatchDelivery) { this.$message.warning('请选择交付日'); return; }
                const g = this.leafGroups.find(x => x.id === this.poolBatchGroup);
                this.batchSubmitting = true;
                try {
                    const { data } = await API.poolBatchRegroup({
                        order_ids: this.selection.map(r => r.order_id).join(','),
                        group_id: this.poolBatchGroup,
                        category_group_id: g ? g.p_group_id : '',
                        delivery: this.poolBatchDelivery || '',
                    });
                    this.notifyResult(data, '批量落点完成：' + ((data && data.count) || 0) + ' 单（已进入已排单）');
                    this.poolBatchDialog = false;
                    this.selection = [];
                    this.refresh();
                } catch (error) {
                    this.$message.error((error && error.info) || '批量落点失败');
                } finally {
                    this.batchSubmitting = false;
                }
            },
            // ---- 撤回（已排/已定版 → 待排单·必填原因） ----
            openWithdraw(row) {
                this.withdrawRow = row;
                this.withdrawBatch = false;
                this.withdrawReason = '';
                this.withdrawDialog = true;
            },
            // 批量撤回（workOrder_v5 §3）：已排/已定版 tab 勾选 → 逐单走服务端 withdraw 五道门，部分成功用 warning 展示服务端汇总
            openBatchWithdraw() {
                if (!this.selection.length) { this.$message.warning('请先勾选要撤回的单'); return; }
                this.withdrawRow = null;
                this.withdrawBatch = true;
                this.withdrawReason = '';
                this.withdrawDialog = true;
            },
            async submitWithdraw() {
                if (!this.withdrawReason || !this.withdrawReason.trim()) { this.$message.warning('请填写撤回原因'); return; }
                this.withdrawLoading = true;
                try {
                    const reason = this.withdrawReason.trim();
                    if (this.withdrawBatch) {
                        const ids = this.selection.map(r => r.order_id);
                        const { info, data } = await API.batchWithdraw({ order_ids: ids, reason });
                        // 部分成功也走 succ：info 已是服务端拼好的人话汇总（撤回成功 N 单；失败 M 单（原因…））
                        if (data && data.fail > 0) this.$message.warning(info || '批量撤回完成');
                        else this.$message.success(info || '批量撤回成功');
                    } else {
                        const { info } = await API.withdraw({ order_id: this.withdrawRow.order_id, reason });
                        this.$message.success(info || '已撤回至待排单');
                    }
                    this.withdrawDialog = false;
                    // 撤回把单从已排/已定版移到待排单，refresh() 重拉列表 + 水位 + tab 徽标
                    this.refresh();
                } catch (error) {
                    this.$message.error((error && error.info) || '撤回失败');
                } finally {
                    this.withdrawLoading = false;
                }
            },
            // ---- 驳回（三 tab·工单 order_status 1→3 被驳回·必填原因≤20字·2026-07-31） ----
            // 前台按钮门：与服务端 rejectOrder 的门对齐（前台只是少让用户白点一次，服务端仍逐条复查——
            // 并发下用户 A 已驳、用户 B 页面没刷新时，前台这几个字段都是旧值）。
            // ⚠️ row.order_status==1 在三 tab 恒真（服务端 buildWhere 已硬写 o.order_status=1），
            //    留着是为了口径自解释，别把它当真实门。
            showRejectBtn(row) {
                if (!this.canReject || this.isOps) return false;
                // 待排单行的可操作标记是 can_operate!=0（同 rowSelectable），已排/已定版是 ==1
                const operable = this.isPool ? row.can_operate != 0 : row.can_operate == 1;
                return operable && row.order_status == 1 && row.in_approval != 1;
            },
            openReject(row) {
                this.rejectRow = row;
                this.rejectBatch = false;
                this.rejectReason = '';
                this.rejectDialog = true;
            },
            openBatchReject() {
                if (!this.selection.length) { this.$message.warning('请先勾选要驳回的单'); return; }
                this.rejectRow = null;
                this.rejectBatch = true;
                this.rejectReason = '';
                this.rejectDialog = true;
            },
            async submitReject() {
                const reason = (this.rejectReason || '').trim();
                if (!reason) { this.$message.warning('请填写驳回原因'); return; }
                // 与服务端 REJECT_REASON_MAX / 指派侧 maxStrLen:20 对齐（el-input maxlength 已挡一道，这里兜底粘贴场景）
                if (reason.length > 20) { this.$message.warning('驳回原因不能超过20个字'); return; }
                this.rejectLoading = true;
                try {
                    if (this.rejectBatch) {
                        const ids = this.selection.map(r => r.order_id);
                        const { info, data } = await API.batchReject({ order_ids: ids, rejected_reason: reason });
                        // 部分成功也走 succ：info 已是服务端拼好的人话汇总（成功 N 单；失败 M 单（原因…））
                        if (data && data.fail > 0) this.$message.warning(info || '批量驳回完成');
                        else this.$message.success(info || '批量驳回成功');
                    } else {
                        const { info } = await API.reject({ order_id: this.rejectRow.order_id, rejected_reason: reason });
                        this.$message.success(info || '驳回成功');
                    }
                    this.rejectDialog = false;
                    // refresh() = 清空勾选 + 重拉列表 + 重算水位 + emit counts-changed 刷 tab 徽标。
                    // 驳回会把单从三个 tab 全部移走（scheduling 行被 purge），徽标必须跟着变，照撤回同款处理。
                    this.refresh();
                } catch (error) {
                    this.$message.error((error && error.info) || '驳回失败');
                } finally {
                    this.rejectLoading = false;
                }
            },
            // ---- 工单详情弹框（按明细行·每 plat/规格一卡） ----
            async openDetail(row) {
                this.detailRow = row;
                this.detailList = [];
                this.detailAttachment = [];
                this.detailDialog = true;
                this.detailLoading = true;
                try {
                    const { data } = await API.detailList({ order_id: row.order_id });
                    // 出参两种形态都兼容：老的是明细数组，新的是 {list, attachment}（2026-08-31 加附件后）。
                    // 这行原本就写成了兼容形态，改后端时正好不用动它。
                    this.detailList = Array.isArray(data) ? data : ((data && data.list) || []);
                    this.detailAttachment = (data && !Array.isArray(data) && data.attachment) || [];
                } catch (error) {
                    this.$message.error((error && error.info) || '获取工单详情失败');
                } finally {
                    this.detailLoading = false;
                }
            },
            // 明细行是否有指派拆分（排单管理里多为待指派·通常空）
            hasAssign(d) {
                return this.allAssign(d).length > 0;
            },
            allAssign(d) {
                return [].concat(
                    d.detail_assign || [],
                    d.detail_can_redo_assign || [],
                    d.detail_cannot_redo_assign || []
                );
            },
            // 多选可选行：待排单=can_operate；已排单=可操作非审批中且 status1
            // 既有口径：哪些行能做排单操作（定版/改落点/换组/置换/驳回/落点）
            rowOperable(row) {
                if (this.isPool) return row.can_operate != 0;
                return row.can_operate == 1 && row.in_approval != 1 && row.order_status == 1;
            },
            // 2026-09-14：持标签权时所有行可勾（标签与排单操作权无关）。
            //   selection 仍只装「可操作行」（既有批量方法零改动），勾到的全量在 rawSelection，仅供改标签用。
            rowSelectable(row) {
                // 持标签权 → 三 tab 所有行可勾（改标签只看节点权·2026-09-22 需求方拍板·BUG-002-BU）；
                // 勾到的全量在 rawSelection 仅供改标签用，selection 仍只装可操作行，其余批量操作不受影响。
                return this.canLabelEdit || this.rowOperable(row);
            },
        },
    };
</script>

<style scoped lang="scss">
    @import "~@/styles/material_sd.scss";

    .filter-del-btn { cursor: pointer; margin-left: 4px; vertical-align: middle; }
    .schedule-manage { padding: 4px 0; }
    .query-box { background: #fff; padding: 20px 10px; border-radius: 4px; }
    .query-box ::v-deep .el-form-item { margin-bottom: 10px; }
    .opts { border-top: 1px solid #DCDFE6; padding-top: 10px; }
    .operation-box { display: flex; justify-content: space-between; align-items: center; }
    .operation-left { display: flex; align-items: center; flex-wrap: wrap; }
    .operation-right { display: flex; align-items: center; flex-wrap: wrap; gap: 6px; }
    .op-tip { margin-left: 8px; color: #909399; font-size: 12px; display: inline-block; max-width: 640px; white-space: normal; line-height: 1.4; vertical-align: middle; }
    .filter-bar { margin-bottom: 4px; }
    /* 产能水位泳道 */
    .water-section { }
    .board-day-pick { display: flex; align-items: center; gap: 10px; margin-bottom: 10px; flex-wrap: wrap; }
    .water-title { font-weight: 600; color: #303133; font-size: 13px; }
    .water-sub { font-size: 12px; color: #909399; }
    .board-lanes { display: grid; grid-template-columns: repeat(auto-fill, minmax(190px, 1fr)); gap: 8px; margin-bottom: 16px; }
    .lane { background: #fff; border: 1px solid #ebeef5; border-radius: 6px; padding: 8px 10px; }
    .lane-head { display: flex; justify-content: space-between; align-items: center; margin-bottom: 5px; }
    .lane-head .lane-name { font-weight: 600; font-size: 13px; line-height: 1.3; }
    .lane-head .lane-name .lane-cat { font-size: 10px; font-weight: 400; color: #909399; margin-left: 4px; }
    .lane-count { font-size: 11px; font-weight: 600; padding: 1px 6px; border-radius: 10px; background: #f4f4f5; color: #606266; white-space: nowrap; }
    .lane-count.over { background: #fef0f0; color: #f56c6c; }
    .lane-count.lane-full { background: #fdf6ec; color: #e6a23c; }
    .lane-count.ok { background: #f0f9eb; color: #67c23a; }
    .lane-bar { height: 7px; background: #f0f2f5; border-radius: 4px; overflow: hidden; position: relative; margin-bottom: 4px; }
    .lane-bar > i { display: block; height: 100%; border-radius: 4px; transition: width .35s; }
    .lane-bar > i.ok { background: #67c23a; }
    .lane-bar > i.lane-full { background: #e6a23c; }
    .lane-bar > i.over { background: #f56c6c; }
    .lane-bar .limit { position: absolute; top: 0; bottom: 0; width: 1px; background: #c0392b; left: 80%; opacity: .7; }
    .lane-val { font-size: 11px; color: #909399; }
    .lane-labs { display: flex; flex-wrap: wrap; align-items: center; gap: 2px 8px; color: #909399; font-size: 11px; margin-top: 2px; } /* §6 档位行·样式对齐指派 .mw-labs */
    .lane-labs .mw-lab { margin: 0; }
    .lane-labs .mw-lab.over { color: #f56c6c; }
    .lane-labs .mw-lab.lane-full { color: #e6a23c; }
    .lane-val.over { color: #f56c6c; font-weight: 600; }
    .lane-expand { color: #67c23a; font-weight: 600; }
    .lane-empty { color: #909399; font-size: 12px; padding: 6px 0; }
    .batch-bar { display: flex; align-items: center; flex-wrap: wrap; gap: 8px; background: #eef5ff; border: 1px solid #d4e6ff; border-radius: 4px; padding: 6px 12px; }
    .batch-bar.bar-in-affix { margin-bottom: 6px; } /* §11：进吸顶块后用块内间距，不再用 mb10 */
    .batch-bar .bb-cnt { font-size: 13px; color: #2b5a8a; }
    .batch-bar .bb-cnt b { color: #409eff; font-size: 14px; }
    .oname { font-weight: 600; color: #303133; }
    .oproj { color: #909399; font-size: 11px; margin-top: 2px; }
    .unit { color: #909399; font-size: 11px; }
    .stars { color: #f7ba2a; letter-spacing: 1px; }
    .star-zero { color: #c0c4cc; }
    .grp-pill { display: inline-block; padding: 1px 8px; border-radius: 4px; background: #f0eefb; color: #7c5cff; font-size: 12px; font-weight: 600; }
    .attach-link { color: #409eff; text-decoration: none; word-break: break-all; }
    .attach-link:hover { text-decoration: underline; }
    .tag-finalized { font-weight: 600; }
    .ml4 { margin-left: 4px; }
    .tar { text-align: right; }
    .dialog-tip { line-height: 1.7; color: #606266; margin: 0 0 6px; font-size: 13px; }
    .dialog-tip-sub { line-height: 1.7; color: #909399; font-size: 12px; margin: 2px 0; }
    .dst-row { padding: 3px 0; border-bottom: 1px dashed #eee; }
    .mb6 { margin-bottom: 6px; }
    .mt6 { margin-top: 6px; }
    .mt10 { margin-top: 10px; }
    .edit-info { background: #f7f9fc; border: 1px solid #ebeef5; border-radius: 4px; padding: 8px 12px; margin-bottom: 12px; line-height: 1.8; font-size: 13px; color: #303133; }
    .edit-info .k { color: #909399; }
    .schedule-manage ::v-deep .ec-keyhead { color: #409eff !important; }
    .schedule-manage ::v-deep .ec-keycell { background: #fbfcff; }
    .schedule-manage ::v-deep .header-cell { background: #e8eaec !important; color: #333 !important; }
    /* 已定版行整行强化：浅绿底 + 左绿条 */
    .schedule-manage ::v-deep .row-finalized td { background: #f3faf3 !important; }
    .schedule-manage ::v-deep .row-finalized td:first-child { box-shadow: inset 3px 0 0 #67c23a; }
    /* 一键预排结果弹框（BUG-002-AJ）·明细区限高滚动（append-to-body 下 .el-dialog__body 的 scoped 深选择器失效，
       改用组件自身元素 .pre-scroll·teleport 后仍带 scoped 属性生效） */
    .pre-scroll { max-height: 55vh; overflow-y: auto; margin: 0 -4px; padding: 0 4px; }
    .pre-sec { margin-bottom: 14px; }
    .pre-sec-hd { font-size: 13px; font-weight: 600; padding: 4px 0; border-bottom: 1px solid #ebeef5; margin-bottom: 4px; }
    .pre-sec-hd.ok { color: #67c23a; }
    .pre-sec-hd.stay { color: #e6a23c; }
    .pre-sec-hd.skip { color: #909399; }
    .pre-row { display: flex; align-items: center; flex-wrap: wrap; gap: 6px; padding: 4px 0; border-bottom: 1px dashed #f0f0f0; font-size: 13px; line-height: 1.6; }
    .pre-name { color: #303133; font-weight: 500; }
    .pre-to { color: #409eff; }
    .pre-od { color: #f56c6c; font-size: 12px; }
    .pre-tag { flex: none; }
    .pre-reason { color: #909399; font-size: 12px; }
    /* 工单详情弹框·限高内部滚动（body 滚动·footer 固定） */
    .detail-body { max-height: 70vh; overflow-y: auto; margin: 0 -4px; padding: 0 4px; }
    .detail-card { border: 1px solid #ebeef5; border-radius: 6px; padding: 10px 12px; margin-bottom: 10px; background: #fff; }
    .detail-card:last-child { margin-bottom: 0; }
    .dc-head { display: flex; align-items: center; flex-wrap: wrap; gap: 4px 14px; font-size: 13px; color: #606266; }
    .dc-head .dc-plat { font-weight: 600; color: #303133; font-size: 14px; }
    .dc-head .dc-meta b { color: #303133; }
    .dc-tags { margin-top: 8px; }
    .dc-assign { margin-top: 8px; border-top: 1px dashed #ebeef5; padding-top: 6px; }
    .dc-assign-hd { font-size: 12px; color: #909399; margin-bottom: 4px; }
    .dc-assign-row { display: flex; align-items: center; flex-wrap: wrap; gap: 6px 14px; font-size: 13px; padding: 3px 0; }
    .dc-assign-row .da-producer { font-weight: 500; color: #303133; }
    .dc-assign-row .da-num, .dc-assign-row .da-time { color: #909399; font-size: 12px; }
    .detail-empty { color: #909399; font-size: 13px; text-align: center; padding: 24px 0; }
</style>
